import { generateLabelsAndValues, generateLabelsAndValuesAndServices, generateLabelsAndValuesforPanelist } from "../utils/HelperFunctions";

export const CERTIFICATE_TYPE = {
    GRADUATE_TECHNOLOGIST: 1,
    QUALIFIED_TECHNICIAN: 2,
    PROFESSIONAL_TECHNOLOGIST: 3,
    CERTIFIED_TECHNICIAN: 4,
    ALL: 5,
    ALL_AVAILABLE: 6,
};

export const CERTIFICATE_STATUS = {
    SUCCESSFUL: 1,
    SELFCHECK: 2,
    REJECTED: 3,
    ACCEPTED: 4,
    //   APPLICATION_REJECTED : 5,
    //   COMPLETED : 6,
    PENDING_APPROVAL_FOR_ASSESSMENT: 7,
    READY_FOR_ASSESSMENT: 8,
    ASSESSMENT_SUCCESSFUL: 9,
    PENDING: 10,
    PENDING_FOR_BOARD_DECISION: 11,
    //   PENDING_APPROVAL_FOR_RENEWAL : 12,
    DEREGISTERED: 13,
    INCOMPLETE_DOCUMENT: 14,
    REFUND: 15,
    CANCELLED: 16,
    PENDING_ENDORSEMENT: 17,
    REFUND_SUCCESS: 18,
    SELFCHECK_SUBMITTED: 19,
    NO_RESPONSE: 20,
    ALL: 21,
    QUEUE_FOR_ASSESSMENT: 26,
    ASSESSMENT_SCHEDULED: 27,
    REMOVAL_DEATH: 22,
    ASSESSMENT_FAILED: 23,
    ADDITIONAL_REVIEW_CHANGE_FIELD: 24,
    ADDITIONAL_REVIEW_ASSESSMENT: 25,
};

export const CERTIFICATE_STATUS_GT_QT = {
    SUCCESSFUL: 1,
    SELFCHECK: 2,
    REJECTED: 3,
    ACCEPTED: 4,
    // APPLICATION_REJECTED: 5,
    // COMPLETED: 6,
    PENDING: 10,
    PENDING_FOR_BOARD_DECISION: 11,
    DEREGISTERED: 13,
    INCOMPLETE_DOCUMENT: 14,
    REFUND: 15,
    REFUND_SUCCESS: 18,
    SELFCHECK_SUBMITTED: 19,
    QUEUE_FOR_ASSESSMENT: 26,
    NO_RESPONSE: 20,
};

export const CERTIFICATE_STATUS_TS_TC = {
    SUCCESSFUL: 1,
    REJECTED: 3,
    ACCEPTED: 4,
    // APPLICATION_REJECTED: 5,
    // COMPLETED: 6,
    READY_FOR_ASSESSMENT: 8,
    ASSESSMENT_SUCCESSFUL: 9,
    PENDING: 10,
    PENDING_FOR_BOARD_DECISION: 11,
    DEREGISTERED: 13,
    REFUND_SUCCESS: 18,
    NO_RESPONSE: 20,
    ASSESSMENT_FAILED: 23,
    QUEUE_FOR_ASSESSMENT: 26,
    ASSESSMENT_SCHEDULED: 27,
    REMOVAL_DEATH: 22,
    ADDITIONAL_REVIEW_CHANGE_FIELD: 24,
    ADDITIONAL_REVIEW_ASSESSMENT: 25,
};

export const CERTIFICATE_TYPE_LABELS_VALUES = generateLabelsAndValues(CERTIFICATE_TYPE);

export const CERTIFICATE_STATUS_GT_QT_LABELS_VALUES = generateLabelsAndValues(CERTIFICATE_STATUS_GT_QT);

export const CERTIFICATE_STATUS_TS_TC_LABELS_VALUES = generateLabelsAndValues(CERTIFICATE_STATUS_TS_TC);

export const CERTIFICATE_STATUS_LABELS_VALUES = generateLabelsAndValues(CERTIFICATE_STATUS);

export const CERTIFICATE_STATUS_TABS = [
    {
        name: "All",
        status: CERTIFICATE_STATUS.ALL,
    },
    {
        name: "Pending Review",
        status: CERTIFICATE_STATUS.PENDING,
    },
    {
        name: "Self-check Needed",
        status: CERTIFICATE_STATUS.SELFCHECK,
    },
    {
        name: "Incomplete Documents",
        status: CERTIFICATE_STATUS.INCOMPLETE_DOCUMENT,
    },
    {
        name: "Accepted",
        status: CERTIFICATE_STATUS.ACCEPTED,
    },
    {
        name: "No Response",
        status: CERTIFICATE_STATUS.NO_RESPONSE,
    },
];

export const CERTIFICATE_STATUS_TS_TC_TABS = [
    {
        name: "All",
        status: CERTIFICATE_STATUS.ALL,
    },
    {
        name: "Queue for Assessment",
        status: CERTIFICATE_STATUS.QUEUE_FOR_ASSESSMENT,
    },
    {
        name: "Ready for Assessment",
        status: CERTIFICATE_STATUS.READY_FOR_ASSESSMENT,
    },
    {
        name: "Assessment Scheduled",
        status: CERTIFICATE_STATUS.ASSESSMENT_SCHEDULED,
    },
    {
        name: "No Response",
        status: CERTIFICATE_STATUS.NO_RESPONSE,
    },
];

export const CERTIFICATE_TYPES_TABS = [
    {
        name: "All",
        type: CERTIFICATE_TYPE.ALL,
    },
    {
        name: "Graduate Technologist",
        type: CERTIFICATE_TYPE.GRADUATE_TECHNOLOGIST,
    },
    {
        name: " Qualified Technician",
        type: CERTIFICATE_TYPE.QUALIFIED_TECHNICIAN,
    },
    {
        name: "Professional Technologist",
        type: CERTIFICATE_TYPE.PROFESSIONAL_TECHNOLOGIST,
    },
    {
        name: "Certified Technician",
        type: CERTIFICATE_TYPE.CERTIFIED_TECHNICIAN,
    },
];

export const PROFILE_INFORMATION = {
    BASIC_INFORMATION: 1,
    ACADEMIC_QUALIFICATIONS: 2,
    WORKING_EXPERIENCE: 3,
    CV: 4,
    PROFESSIONAL_CERTIFICATE: 5,
    SUMMARY: 6,
    REFERENCE: 7,
};

export const PROFILE_INFORMATION_TABS = [
    {
        name: "Basic Information",
        type: PROFILE_INFORMATION.BASIC_INFORMATION,
    },
    {
        name: "Academic Qualifications",
        type: PROFILE_INFORMATION.ACADEMIC_QUALIFICATIONS,
    },
    {
        name: "Working Experience",
        type: PROFILE_INFORMATION.WORKING_EXPERIENCE,
    },
    {
        name: "CV",
        type: PROFILE_INFORMATION.CV,
    },
    {
        name: "Professional Certificate",
        type: PROFILE_INFORMATION.PROFESSIONAL_CERTIFICATE,
    },
    {
        name: "Self Check",
        type: PROFILE_INFORMATION.SUMMARY,
    },
    {
        name: "Reference",
        type: PROFILE_INFORMATION.REFERENCE,
    },
];

export const TechnologyFieldsOptions = [
    {
        label: "Aerospace and aviation technology (AV)",
        value: 1,
        sub_fields: [
            {
                label: "Engineering & Design",
                value: 1,
            },
            {
                label: "Aerospace Manufacturing",
                value: 2,
            },
            {
                label: "Systems Integration",
                value: 3,
            },
            {
                label: "Maintenance, Repair & Overhaul",
                value: 4,
            },
            {
                label: "Continuing Airworthiness Management Organisation (CAMO)",
                value: 5,
            },
            {
                label: "Aerospace Support Services",
                value: 6,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Ramesh Sabapathy",
                value: "YBrs. Ts. Ramesh Sabapathy",
            },
            {
                label: "YBrs. Ts. Dr. Latifah binti Md Ariffin",
                value: "YBrs. Ts. Dr. Latifah binti Md Ariffin",
            },
            {
                label: "YBrs. Ts. Dr. Wan Mohd Sufian bin Wan Husain",
                value: "YBrs. Ts. Dr. Wan Mohd Sufian bin Wan Husain",
            },
            {
                label: "YBrs. Ts. Karnanethe A/L Ramasamy",
                value: "YBrs. Ts. Karnanethe A/L Ramasamy",
            },
            {
                label: "YBrs. Ts. Dr. Aslam bin Abdullah",
                value: "YBrs. Ts. Dr. Aslam bin Abdullah",
            },
            {
                label: "YBrs. Ts. Norhisyam bin Berawi",
                value: "YBrs. Ts. Norhisyam bin Berawi",
            },
            {
                label: "YBrs. Ts. Az Afzan Zuhairi bin Mohamed Azhar",
                value: "YBrs. Ts. Az Afzan Zuhairi bin Mohamed Azhar",
            },
            {
                label: "YBrs. Ts. Muhamad Farouk bin Abdul Rashid",
                value: "YBrs. Ts. Muhamad Farouk bin Abdul Rashid",
            },
            {
                label: "YBrs. MEJ Ts. Ir. Dr. Arvinthan Venugopal",
                value: "YBrs. MEJ Ts. Ir. Dr. Arvinthan Venugopal",
            },
            {
                label: "YBrs. Ts. Sathyaraj A/L G. Palanivelu",
                value: "YBrs. Ts. Sathyaraj A/L G. Palanivelu",
            },
            {
                label: "YBrs. Ts. Muhamad Zaki bin Md Sabri",
                value: "YBrs. Ts. Muhamad Zaki bin Md Sabri",
            },
            {
                label: "YBrs. Tc. Shahrul Nizam bin Harun",
                value: "YBrs. Tc. Shahrul Nizam bin Harun",
            },
            {
                label: "YBrs. Ts. Ahmad Firdaus bin Dahalan",
                value: "YBrs. Ts. Ahmad Firdaus bin Dahalan",
            },
            {
                label: "YBrs. Ts. Charles Tee Chow Yi",
                value: "YBrs. Ts. Charles Tee Chow Yi",
            },
            {
                label: "YBrs. Tc. Mohd Nazrul bin Md Zin",
                value: "YBrs. Tc. Mohd Nazrul bin Md Zin",
            },
            {
                label: "YBrs. Ts. Joel Lim Soon Yeen",
                value: "YBrs. Ts. Joel Lim Soon Yeen",
            },
            {
                label: "YBrs. Ts. Nurul Hazwani binti Hamzah",
                value: "YBrs. Ts. Nurul Hazwani binti Hamzah",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Harlisya binti Hj. Harun",
                value: "YBrs. Prof. Madya Ts. Dr. Harlisya binti Hj. Harun",
            },
            {
                label: "YBrs. Ts. Dr. Ahmad Hussein bin Abdul Hamid",
                value: "YBrs. Ts. Dr. Ahmad Hussein bin Abdul Hamid",
            },
            {
                label: "YBrs. Ts. Teoh Thean Hin",
                value: "YBrs. Ts. Teoh Thean Hin",
            }
        ],
    },
    {
        label: "Agro-based technology (AF)",
        value: 2,
        sub_fields: [
            {
                label: "Agriculture Ecosystem and Services",
                value: 1,
            },
            {
                label: "Crop science",
                value: 2,
            },
            {
                label: "Animal science",
                value: 3,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Farah binti Abu Bakar",
                value: "YBrs. Ts. Farah binti Abu Bakar",
            },
            {
                label: "YBrs. Ts. Wan Zulkarnain bin Othman",
                value: "YBrs. Ts. Wan Zulkarnain bin Othman",
            },
            {
                label: "YBrs. Ts. Roshita binti Ibrahim",
                value: "YBrs. Ts. Roshita binti Ibrahim",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Nor Azma binti Yusuf",
                value: "YBrs. Prof. Madya Ts. Dr. Nor Azma binti Yusuf",
            }
        ],
    },
    {
        label: "Art design & creative multimedia technology (AM)",
        value: 3,
        sub_fields: [
            {
                label: "Creative Multimedia",
                value: 1,
            },
            {
                label: "Art & Design",
                value: 2,
            },
            {
                label: "Entertainment",
                value: 3,
            },
            {
                label: "Games Development",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Ts. Dr. Neo Tse Kian",
                value: "YBrs. Prof. Ts. Dr. Neo Tse Kian",
            },
            {
                label: "YBrs. Ts. Dr. Rainal Hidayat bin Wardi",
                value: "YBrs. Ts. Dr. Rainal Hidayat bin Wardi",
            },
            {
                label: "YBrs. Ts. Liew Foong Ching",
                value: "YBrs. Ts. Liew Foong Ching",
            },
            {
                label: "YBrs. Ts. Dr. Wong Chui Yin",
                value: "YBrs. Ts. Dr. Wong Chui Yin",
            },
            {
                label: "YBrs. Ts. Rusmadiah bin Anwar",
                value: "YBrs. Ts. Rusmadiah bin Anwar",
            },
            {
                label: "YBrs. Ts. Dr. Ang Kok Yew",
                value: "YBrs. Ts. Dr. Ang Kok Yew",
            },
            {
                label: "YBrs. Tc. Mohamad Isa bin Tukimin",
                value: "YBrs. Tc. Mohamad Isa bin Tukimin",
            },
            {
                label: "YBrs. Ts. Khairudin bin Baharum",
                value: "YBrs. Ts. Khairudin bin Baharum",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Anuar bin Mohd Yusof",
                value: "YBrs. Prof. Madya Ts. Dr. Anuar bin Mohd Yusof",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Wan Aida binti Wan Yahaya",
                value: "YBrs. Prof. Madya Ts. Dr. Wan Aida binti Wan Yahaya",
            },
            {
                label: "YBrs. Ts. Dr. Maria binti Hj Mohammad",
                value: "YBrs. Ts. Dr. Maria binti Hj Mohammad",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Dr. Lim Ean Heng",
                value: "YBrs. Prof. Madya. Ts. Dr. Lim Ean Heng",
            },
            {
                label: "YBrs. Tc. Jefri bin Dahlan",
                value: "YBrs. Tc. Jefri bin Dahlan",
            },
            {
                label: "YBrs. Ts. Saadiah binti A Rahman",
                value: "YBrs. Ts. Saadiah binti A Rahman",
            },
            {
                label: "YBrs. Ts. Mohd Fadzley bin Abd Shukor",
                value: "YBrs. Ts. Mohd Fadzley bin Abd Shukor",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Tan Chin Ike",
                value: "YBrs. Prof. Madya Ts. Dr. Tan Chin Ike",
            },
            {
                label: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
                value: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Dr. Noraini binti Seman",
                value: "YBrs. Prof. Madya. Ts. Dr. Noraini binti Seman",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Dr. Tan Tse Guan",
                value: "YBrs. Prof. Madya. Ts. Dr. Tan Tse Guan",
            },
            {
                label: "YBrs. Ts. Dr. Azliza binti Yacob",
                value: "YBrs. Ts. Dr. Azliza binti Yacob",
            },
            {
                label: "YBrs. Ts. Shashi Muniandy",
                value: "YBrs. Ts. Shashi Muniandy",
            }
        ],
    },
    {
        label: "Atmospheric science & environment technology (AC)",
        value: 4,
        sub_fields: [
            {
                label: "Meteorology",
                value: 1,
            },
            {
                label: "Climate Change",
                value: 2,
            },
            {
                label: "Environmental Technologies",
                value: 3,
            },
            {
                label: "Ecology",
                value: 4,
            },
            {
                label: "Geophysics and Disaster",
                value: 5,
            },
            {
                label: "Hydrology",
                value: 6,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Mohd Hafiz bin Ab Rahman",
                value: "YBrs. Ts. Mohd Hafiz bin Ab Rahman",
            },
            {
                label: "YBrs. Ts. Dr. Noor Zaitun binti Yahaya",
                value: "YBrs. Ts. Dr. Noor Zaitun binti Yahaya",
            },
            {
                label: "YBrs. Ts. Tan Poh Aun",
                value: "YBrs. Ts. Tan Poh Aun",
            },
            {
                label: "YBrs. Ts. Dr. Siti Birkha binti Mohd Ali",
                value: "YBrs. Ts. Dr. Siti Birkha binti Mohd Ali",
            },
            {
                label: "YBrs. Ts. Dr. Roslaili binti Abdul Aziz",
                value: "YBrs. Ts. Dr. Roslaili binti Abdul Aziz",
            },
            {
                label: "YBrs. Ts. Mohd Zulhafiz bin Mohd Yajid",
                value: "YBrs. Ts. Mohd Zulhafiz bin Mohd Yajid",
            }
        ],
    },
    {
        label: "Automotive technology (AT)",
        value: 5,
        sub_fields: [
            {
                label: "Automotive Manufacturing",
                value: 1,
            },
            {
                label: "Powertrain",
                value: 2,
            },
            {
                label: "Technical/Technology Design",
                value: 3,
            },
            {
                label: "Mechanic automotive",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Ts. Dr. Mohd Ruzaimi bin Mat Rejab",
                value: "YBrs. Prof. Ts. Dr. Mohd Ruzaimi bin Mat Rejab",
            },
            {
                label: "YBrs. Ts. Mohd. Fazil bin Jundam",
                value: "YBrs. Ts. Mohd. Fazil bin Jundam",
            },
            {
                label: "YBrs. Ts. Ahmad Sobri bin Ahmad Hudin",
                value: "YBrs. Ts. Ahmad Sobri bin Ahmad Hudin",
            },
            {
                label: "YBrs. Ts. Ir. Adnan bin Katijan",
                value: "YBrs. Ts. Ir. Adnan bin Katijan",
            },
            {
                label: "YBrs. Tc. Azli bin Ithnain",
                value: "YBrs. Tc. Azli bin Ithnain",
            },
            {
                label: "YBrs. Ts. Ir.  Ahmad Nazir bin Kamaruddin",
                value: "YBrs. Ts. Ir.  Ahmad Nazir bin Kamaruddin",
            },
            {
                label: "YBrs. Ts. Mohammad Al Bukhari bin Marzuki",
                value: "YBrs. Ts. Mohammad Al Bukhari bin Marzuki",
            },
            {
                label: "YBrs. Ts. Nor Hissham bin Abdul Hamid",
                value: "YBrs. Ts. Nor Hissham bin Abdul Hamid",
            },
            {
                label: "YBrs. Ts. Hairul Nizan bin Sulaiman",
                value: "YBrs. Ts. Hairul Nizan bin Sulaiman",
            },
            {
                label: "YBrs. Ts. Mohd Hazwan bin Mohamed Norli",
                value: "YBrs. Ts. Mohd Hazwan bin Mohamed Norli",
            },
            {
                label: "YBrs. Ts. Dr. Hanida binti Abdullah",
                value: "YBrs. Ts. Dr. Hanida binti Abdullah",
            },
            {
                label: "YBrs. Ts. Hisham bin Ismoi",
                value: "YBrs. Ts. Hisham bin Ismoi",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
                value: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Azmi bin Ahmad",
                value: "YBrs. Ts. Ir. Dr. Azmi bin Ahmad",
            },
            {
                label: "YBrs. Tc. Mohd Husaini bin Seman",
                value: "YBrs. Tc. Mohd Husaini bin Seman",
            },
            {
                label: "YBrs. Ts. Zarir Hafiz bin Zulkipli",
                value: "YBrs. Ts. Zarir Hafiz bin Zulkipli",
            },
            {
                label: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
                value: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
            },
            {
                label: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
                value: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
            },
            {
                label: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
                value: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
            },
            {
                label: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
                value: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
            }
        ],
    },
    {
        label: "Biotechnology (BT)",
        value: 6,
        sub_fields: [
            {
                label: "Agriculture Biotechnology",
                value: 1,
            },
            {
                label: "Industrial Biotechnology",
                value: 2,
            },
            {
                label: "Healthcare Biotechnology",
                value: 3,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Madya Ts. Dr. Ruzainah binti Ali @ Jaafar",
                value: "YBrs. Prof. Madya Ts. Dr. Ruzainah binti Ali @ Jaafar",
            },
            {
                label: "YBrs. Ts. Dr. Shamsiah binti Abdullah",
                value: "YBrs. Ts. Dr. Shamsiah binti Abdullah",
            },
            {
                label: "YBrs. Ts. Gs. Dr. Kamarul Rahim bin Kamaruddin",
                value: "YBrs. Ts. Gs. Dr. Kamarul Rahim bin Kamaruddin",
            },
            {
                label: "YBrs. Ts. Dr. Nurulisa binti Zulkifle",
                value: "YBrs. Ts. Dr. Nurulisa binti Zulkifle",
            },
            {
                label: "YBrs. Ts. Mohd Zuhaimi bin Yacob",
                value: "YBrs. Ts. Mohd Zuhaimi bin Yacob",
            },
            {
                label: "YBrs. Ts. Rusidah binti Mat Yatim",
                value: "YBrs. Ts. Rusidah binti Mat Yatim",
            },
            {
                label: "YBrs. Ts. Dr. Rajiv A/L Ravi",
                value: "YBrs. Ts. Dr. Rajiv A/L Ravi",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Mohd Nasir bin Mohd Desa",
                value: "YBrs. Prof. Ts. Dr. Mohd Nasir bin Mohd Desa",
            },
            {
                label: "YBrs. Ts. Dr. A Angeli A/P Ambayya @ Ampiah",
                value: "YBrs. Ts. Dr. A Angeli A/P Ambayya @ Ampiah",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Nor Azma binti Yusuf",
                value: "YBrs. Prof. Madya Ts. Dr. Nor Azma binti Yusuf",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Solehuddin bin Shuib",
                value: "YBrs. Prof. Ts. Ir. Dr. Solehuddin bin Shuib",
            },
            {
                label: "YBrs. Ts. Che Rahmat bin Che Mat",
                value: "YBrs. Ts. Che Rahmat bin Che Mat",
            },
            {
                label: "YBrs. Ts. Dr. Amir Syahir bin Amir Hamzah",
                value: "YBrs. Ts. Dr. Amir Syahir bin Amir Hamzah",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
                value: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
                value: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
            },
            {
                label: "YBrs. Ts. ChM. Dr. Khalisanni bin Khalid",
                value: "YBrs. Ts. ChM. Dr. Khalisanni bin Khalid",
            }
        ],
    },
    {
        label: "Building & construction technology (BC)",
        value: 7,
        sub_fields: [
            {
                label: "Infra works",
                value: 1,
            },
            {
                label: "Building Works",
                value: 2,
            },
            {
                label: "Architecture",
                value: 3,
            },
            {
                label: "Property and Facilities Management",
                value: 4,
            },
            {
                label: "Contract Management",
                value: 5,
            },
            {
                label: "Road & Bridge",
                value: 6,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Ir.  Dr. Mohd Kamaruzaman bin Musa",
                value: "YBrs. Ts. Ir.  Dr. Mohd Kamaruzaman bin Musa",
            },
            {
                label: "YBrs. Ts. Mohamad Yusri bin Hj. Yusoff",
                value: "YBrs. Ts. Mohamad Yusri bin Hj. Yusoff",
            },
            {
                label: "YBrs. Ts. Gunalaan Vasudevan",
                value: "YBrs. Ts. Gunalaan Vasudevan",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Mohamad Hairi bin Osman",
                value: "YBrs. Ts. Ir. Dr. Mohamad Hairi bin Osman",
            },
            {
                label: "YBrs. Ts. Ir. Nik Mohd Nadzri bin Nik Mustapha",
                value: "YBrs. Ts. Ir. Nik Mohd Nadzri bin Nik Mustapha",
            },
            {
                label: "YBrs. Ts. Ir. Chong Chee Yen",
                value: "YBrs. Ts. Ir. Chong Chee Yen",
            },
            {
                label: "YBrs. Ts. Mohd Yusaini bin Mohd Yunus",
                value: "YBrs. Ts. Mohd Yusaini bin Mohd Yunus",
            },
            {
                label: "YBrs. Ts. Muhamad Yusof bin Abdullah",
                value: "YBrs. Ts. Muhamad Yusof bin Abdullah",
            },
            {
                label: "YBrs. Ts. Ho Chee Leong",
                value: "YBrs. Ts. Ho Chee Leong",
            },
            {
                label: "YBrs. Ts. Andy Tiong Meng Jun",
                value: "YBrs. Ts. Andy Tiong Meng Jun",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Rumaizah binti Mohd Nordin",
                value: "YBrs. Prof. Madya Ts. Dr. Rumaizah binti Mohd Nordin",
            },
            {
                label: "YBrs. Ts. Mohammad Ikhsan bin Mohamad Bahrin",
                value: "YBrs. Ts. Mohammad Ikhsan bin Mohamad Bahrin",
            },
            {
                label: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
                value: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
            },
            {
                label: "YBrs. Ts. Prof. Madya Dr. Adnan bin Derahman",
                value: "YBrs. Ts. Prof. Madya Dr. Adnan bin Derahman",
            },
            {
                label: "YBrs. Ts. Nor Aini binti Rosli",
                value: "YBrs. Ts. Nor Aini binti Rosli",
            },
            {
                label: "YBrs. Ts. Gs. Zaid Iskandar bin Jaraiee",
                value: "YBrs. Ts. Gs. Zaid Iskandar bin Jaraiee",
            },
            {
                label: "YBrs. Ts. Mohamad Rizal bin Abdullah",
                value: "YBrs. Ts. Mohamad Rizal bin Abdullah",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Nazli bin Zakaria",
                value: "YBrs. Ts. Ir. Mohd Nazli bin Zakaria",
            },
            {
                label: "YBrs. Ts. Muhammad Asyraf bin Masri",
                value: "YBrs. Ts. Muhammad Asyraf bin Masri",
            },
            {
                label: "YBrs. Kol. Ts. Norhelmi bin Ismail",
                value: "YBrs. Kol. Ts. Norhelmi bin Ismail",
            },
            {
                label: "YBrs. Ts. Ir. Wan Mohd Fadzil bin Wan Sapiansori",
                value: "YBrs. Ts. Ir. Wan Mohd Fadzil bin Wan Sapiansori",
            },
            {
                label: "YBrs. Ts. Soong Looi Sing",
                value: "YBrs. Ts. Soong Looi Sing",
            },
            {
                label: "YBrs. Ts. Mohd Ariff bin Mohd Jafri",
                value: "YBrs. Ts. Mohd Ariff bin Mohd Jafri",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Hisam bin Sa'at",
                value: "YBrs. Ts. Ir. Mohd Hisam bin Sa'at",
            },
            {
                label: "YBrs. Ts. Muhamad Faiz bin Musa",
                value: "YBrs. Ts. Muhamad Faiz bin Musa",
            },
            {
                label: "YBrs. Ts. Br. Mohd Dhiya Hafreez bin Kamil",
                value: "YBrs. Ts. Br. Mohd Dhiya Hafreez bin Kamil",
            },
            {
                label: "YBrs. Ts. Ng Yeong Shan",
                value: "YBrs. Ts. Ng Yeong Shan",
            },
            {
                label: "YBrs. Ts. Abdul Latif bin Azis",
                value: "YBrs. Ts. Abdul Latif bin Azis",
            },
            {
                label: "YBrs. Lt. Kol. Ts. Gs. Abdul Rashid bin Othman",
                value: "YBrs. Lt. Kol. Ts. Gs. Abdul Rashid bin Othman",
            },
            {
                label: "YBrs. Ts. Leong Yee Nam",
                value: "YBrs. Ts. Leong Yee Nam",
            },
            {
                label: "YBrs. Ts. Anas bin Abdul Halim",
                value: "YBrs. Ts. Anas bin Abdul Halim",
            },
            {
                label: "YBrs. Tc. Abdul Rauf bin Mat Foor",
                value: "YBrs. Tc. Abdul Rauf bin Mat Foor",
            },
            {
                label: "YBrs. Ts. Ir. Akhtar Nurfitri bin Mat Zain",
                value: "YBrs. Ts. Ir. Akhtar Nurfitri bin Mat Zain",
            },
            {
                label: "YBrs. Ts. Yusran bin Ariffin",
                value: "YBrs. Ts. Yusran bin Ariffin",
            },
            {
                label: "YBrs. Ts. Mohd Aizat bin Mohamad Roseli",
                value: "YBrs. Ts. Mohd Aizat bin Mohamad Roseli",
            },
            {
                label: "YBrs. Ts. Herman bin Yahya",
                value: "YBrs. Ts. Herman bin Yahya",
            },
            {
                label: "YBrs. Ts. Agus Irawan bin Hasanudin",
                value: "YBrs. Ts. Agus Irawan bin Hasanudin",
            },
            {
                label: "YBrs. Ts. Teo Kok Wei",
                value: "YBrs. Ts. Teo Kok Wei",
            },
            {
                label: "YBrs. Ts. Ida Liyani binti Ahmad",
                value: "YBrs. Ts. Ida Liyani binti Ahmad",
            },
            {
                label: "YBrs. Ts. Ir. Sim See Yoong",
                value: "YBrs. Ts. Ir. Sim See Yoong",
            },
            {
                label: "YBrs. Ts. Nor Hasfilah binti Anwar",
                value: "YBrs. Ts. Nor Hasfilah binti Anwar",
            },
            {
                label: "YBrs. Ts. Sr. Azmi bin Ramli",
                value: "YBrs. Ts. Sr. Azmi bin Ramli",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Khairulnizam bin Mohmmed Haasan",
                value: "YBrs. Ts. Ir. Mohd Khairulnizam bin Mohmmed Haasan",
            },
            {
                label: "YBrs. Ts. Mohd Shahrizan bin Asmawi",
                value: "YBrs. Ts. Mohd Shahrizan bin Asmawi",
            },
            {
                label: "YBrs. Prof. Madya Ts. Sr. Dr. Hayroman bin Ahmad",
                value: "YBrs. Prof. Madya Ts. Sr. Dr. Hayroman bin Ahmad",
            },
            {
                label: "YBrs. Ts. Ir. Hj. Mohd Shuzainy bin Ismail",
                value: "YBrs. Ts. Ir. Hj. Mohd Shuzainy bin Ismail",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Firdaus bin Mustaffa Kamal",
                value: "YBrs. Ts. Dr. Mohd Firdaus bin Mustaffa Kamal",
            },
            {
                label: "YBrs. Ts. Ir. Gs. Br. Mohd Mawardi bin Hassim",
                value: "YBrs. Ts. Ir. Gs. Br. Mohd Mawardi bin Hassim",
            },
            {
                label: "YBrs. Ts. Mohammad Tamizi bin Selimin",
                value: "YBrs. Ts. Mohammad Tamizi bin Selimin",
            },
            {
                label: "YBrs. Ts. Mohd Fathi Syahid bin Ruzali",
                value: "YBrs. Ts. Mohd Fathi Syahid bin Ruzali",
            },
            {
                label: "YBrs. Ts. Dr. Haryati binti Yaacob",
                value: "YBrs. Ts. Dr. Haryati binti Yaacob",
            },
            {
                label: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
                value: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Rusdi bin Rusli",
                value: "YBrs. Ts. Ir. Dr. Rusdi bin Rusli",
            },
            {
                label: "YBrs. Tc. Affendy bin Din",
                value: "YBrs. Tc. Affendy bin Din",
            },
            {
                label: "YBrs. Ts. Ir. Br. Noorhazilah binti baharin",
                value: "YBrs. Ts. Ir. Br. Noorhazilah binti baharin",
            },
            {
                label: "YBrs. Ts.  Ir. Nor Azery bin Abd Rahim",
                value: "YBrs. Ts.  Ir. Nor Azery bin Abd Rahim",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Sulzakimin bin Mohamed",
                value: "YBrs. Prof. Madya Ts. Dr. Sulzakimin bin Mohamed",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Khairolden bin Ghani",
                value: "YBrs. Ts. Dr. Mohd Khairolden bin Ghani",
            },
            {
                label: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
                value: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
            },
            {
                label: "YBrs. Ts. Dr. George Decruz",
                value: "YBrs. Ts. Dr. George Decruz",
            }
        ],
    },
    {
        label: "Chemical technology (CM)",
        value: 8,
        sub_fields: [
            {
                label: "Product",
                value: 1,
            },
            {
                label: "Process",
                value: 2,
            },
            {
                label: "Product Services",
                value: 3,
            },
            {
                label: "Commercial Technical Services",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Dr. Zulhafiz bin Tajudin",
                value: "YBrs. Ts. Dr. Zulhafiz bin Tajudin",
            },
            {
                label: "YBrs. Ts. Dr. Wan Zarina binti Wan Mohamed",
                value: "YBrs. Ts. Dr. Wan Zarina binti Wan Mohamed",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
                value: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
            },
            {
                label: "YBrs. Ts. Muhamad Azwat bin Abdullah",
                value: "YBrs. Ts. Muhamad Azwat bin Abdullah",
            },
            {
                label: "YBrs. Ts. ChM. Dr. Irmaizatussyehdany binti Buniyamin",
                value: "YBrs. Ts. ChM. Dr. Irmaizatussyehdany binti Buniyamin",
            },
            {
                label: "YBrs. Ts. ChM. Mohd Naim bin Abdul Halim",
                value: "YBrs. Ts. ChM. Mohd Naim bin Abdul Halim",
            },
            {
                label: "YBrs. Ts. Che Rahmat bin Che Mat",
                value: "YBrs. Ts. Che Rahmat bin Che Mat",
            },
            {
                label: "YBrs.Ts. ChM. Dr. Khalisanni bin Khalid",
                value: "YBrs.Ts. ChM. Dr. Khalisanni bin Khalid",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Sharizan bin Md Sarip",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Sharizan bin Md Sarip",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
            },
            {
                label: "YBrs. Ts. Ameran bin Saiman",
                value: "YBrs. Ts. Ameran bin Saiman",
            },
            {
                label: "YBrs. Ts. Dr. George Decruz",
                value: "YBrs. Ts. Dr. George Decruz",
            }
        ],
    },
    {
        label: "Cyber security technology (CS)",
        value: 9,
        sub_fields: [
            {
                label: "Information Assurance",
                value: 1,
            },
            {
                label: "Network Security",
                value: 2,
            },
            {
                label: "Data Security",
                value: 3,
            },
            {
                label: "Societal and Organizational Security",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Khairul Nadzmi bin Mohd Yusof",
                value: "YBrs. Ts. Khairul Nadzmi bin Mohd Yusof",
            },
            {
                label: "YBrs. Ts. Dr. Johari bin Jalaludin",
                value: "YBrs. Ts. Dr. Johari bin Jalaludin",
            },
            {
                label: "YBrs. Ts. Alan Yau Ti Dun",
                value: "YBrs. Ts. Alan Yau Ti Dun",
            },
            {
                label: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
                value: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Nik Zulkarnaen bin Khidzir",
                value: "YBrs. Prof. Madya Ts. Dr. Nik Zulkarnaen bin Khidzir",
            },
            {
                label: "YBhg. Datin Dr. Ts. Siti Hanom binti Marjuni",
                value: "YBhg. Datin Dr. Ts. Siti Hanom binti Marjuni",
            },
            {
                label: "YBrs. Ts. Ir. Zamrin bin Md Zin",
                value: "YBrs. Ts. Ir. Zamrin bin Md Zin",
            },
            {
                label: "YBrs. Ts. Dr. Azliza binti Yacob",
                value: "YBrs. Ts. Dr. Azliza binti Yacob",
            },
            {
                label: "YBrs. Insp. Ts. Mohd Norzikri bin Kamaruddin",
                value: "YBrs. Insp. Ts. Mohd Norzikri bin Kamaruddin",
            },
            {
                label: "YBrs. Ts. Saiful Bakhtiar bin Osman",
                value: "YBrs. Ts. Saiful Bakhtiar bin Osman",
            },
            {
                label: "YBrs. Ts. Shashi Muniandy",
                value: "YBrs. Ts. Shashi Muniandy",
            },
            {
                label: "YBrs. Ts. Ediwarman bin Mohamad Taher",
                value: "YBrs. Ts. Ediwarman bin Mohamad Taher",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Noor Afiza binti Mat Razali",
                value: "YBrs. Prof. Madya Ts. Dr. Noor Afiza binti Mat Razali",
            },
            {
                label: "YBrs. Ts. Mohammed Khairil Adzhar bin Mohammed",
                value: "YBrs. Ts. Mohammed Khairil Adzhar bin Mohammed",
            },
            {
                label: "YBrs. Ts. Jaiz Anuar bin Yeop Johari",
                value: "YBrs. Ts. Jaiz Anuar bin Yeop Johari",
            },
            {
                label: "YBrs. Ts. Arief Affendi bin Ab Wahab",
                value: "YBrs. Ts. Arief Affendi bin Ab Wahab",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
                value: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
            }
        ],
    },
    {
        label: "Electrical & electronics technology (EE)",
        value: 10,
        sub_fields: [
            {
                label: "Power - Generation, transmissions & distribution",
                value: 1,
            },
            {
                label: "Semiconductor",
                value: 2,
            },
            {
                label: "Control & Instrumentation",
                value: 3,
            },
            {
                label: "Signal Processing",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
                value: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
                value: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
            },
            {
                label: "YBrs. Ts. Hazrizam bin Ab Rahim",
                value: "YBrs. Ts. Hazrizam bin Ab Rahim",
            },
            {
                label: "YBrs. Ts. Kon Qi Yao",
                value: "YBrs. Ts. Kon Qi Yao",
            },
            {
                label: "YBrs. Tc. Musa bin Mohd Yusuf",
                value: "YBrs. Tc. Musa bin Mohd Yusuf",
            },
            {
                label: "YBrs. Ts. Ong Seng Keong",
                value: "YBrs. Ts. Ong Seng Keong",
            },
            {
                label: "YBrs. Ts. Dr. Muhammad Ikhwan bin Zamhuri",
                value: "YBrs. Ts. Dr. Muhammad Ikhwan bin Zamhuri",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Junita binti Mohd Nordin",
                value: "YBrs. Prof. Madya Ts. Dr. Junita binti Mohd Nordin",
            },
            {
                label: "YBrs. Ts. Dr. Haris Fazilah bin Hassan",
                value: "YBrs. Ts. Dr. Haris Fazilah bin Hassan",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Muzamir bin Isa",
                value: "YBrs. Prof. Ts. Dr. Muzamir bin Isa",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Noramin bin Ab Aziz",
                value: "YBrs. Ts. Ir. Mohd Noramin bin Ab Aziz",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Muammar bin Mohamad Isa",
                value: "YBrs. Prof. Madya Ts. Dr. Muammar bin Mohamad Isa",
            },
            {
                label: "YBrs. Ts. Ir. Ahmad Zawawi bin Kasmin",
                value: "YBrs. Ts. Ir. Ahmad Zawawi bin Kasmin",
            },
            {
                label: "YBrs. Ts. Dr. Faizah binti Abu Bakar",
                value: "YBrs. Ts. Dr. Faizah binti Abu Bakar",
            },
            {
                label: "YBrs. Ts. Abdul Halim bin Abd Rahman",
                value: "YBrs. Ts. Abdul Halim bin Abd Rahman",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
            },
            {
                label: "YBrs. Ts. Hoo Mow Heng",
                value: "YBrs. Ts. Hoo Mow Heng",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
                value: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Kismet Anak Hong Ping",
                value: "YBrs. Prof. Ts. Ir. Dr. Kismet Anak Hong Ping",
            },
            {
                label: "YBrs. Ts. Mohd Farihan bin Jamaludin",
                value: "YBrs. Ts. Mohd Farihan bin Jamaludin",
            },
            {
                label: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
                value: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
            },
            {
                label: "YBrs. Ts. Dr. Segar Rajamanickam",
                value: "YBrs. Ts. Dr. Segar Rajamanickam",
            },
            {
                label: "YBrs. Ts. Dr. Zunuwanas bin Mohamad",
                value: "YBrs. Ts. Dr. Zunuwanas bin Mohamad",
            },
            {
                label: "YBrs. Ts. Ir. Zainudin bin Jusoh",
                value: "YBrs. Ts. Ir. Zainudin bin Jusoh",
            },
            {
                label: "YBrs. Ts. Petrus Julini Anak Goel",
                value: "YBrs. Ts. Petrus Julini Anak Goel",
            },
            {
                label: "YBrs. Ts. Dr. Wan Nasarudin bin Wan Jalal",
                value: "YBrs. Ts. Dr. Wan Nasarudin bin Wan Jalal",
            },
            {
                label: "YBrs. Ts. Abdul Hadi bin Kasmoni",
                value: "YBrs. Ts. Abdul Hadi bin Kasmoni",
            },
            {
                label: "YBrs. Tc. Kamarul Azman bin Mohd Ikram",
                value: "YBrs. Tc. Kamarul Azman bin Mohd Ikram",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
                value: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
            },
            {
                label: "YBrs. Tc. Mohini bin Kamaruddin",
                value: "YBrs. Tc. Mohini bin Kamaruddin",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Puzi bin Yusop",
                value: "YBrs. Ts. Ir. Mohd Puzi bin Yusop",
            },
            {
                label: "YBrs. Ts. Lely Merlina binti Ismayatim",
                value: "YBrs. Ts. Lely Merlina binti Ismayatim",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Halimatun binti Hashim",
                value: "YBrs. Ts. Ir. Dr. Halimatun binti Hashim",
            },
            {
                label: "YBrs. Ts. Abu Hanifah bin Che Abd Aziz",
                value: "YBrs. Ts. Abu Hanifah bin Che Abd Aziz",
            },
            {
                label: "YBrs. Ts. Nor Fazlin bin Ahmad",
                value: "YBrs. Ts. Nor Fazlin bin Ahmad",
            },
            {
                label: "YBrs. Tc. Affendy bin Din",
                value: "YBrs. Tc. Affendy bin Din",
            },
            {
                label: "YBrs. Ts. Mohd Fahmi bin Sulaiman",
                value: "YBrs. Ts. Mohd Fahmi bin Sulaiman",
            },
            {
                label: "YBrs. Ts. Nantha Govindan",
                value: "YBrs. Ts. Nantha Govindan",
            },
            {
                label: "YBrs. Ts. Aizul Fazli bin Suhaimi",
                value: "YBrs. Ts. Aizul Fazli bin Suhaimi",
            },
            {
                label: "YBrs. Ts.  Ir. Mohd Firdaus bin Jalaluddin",
                value: "YBrs. Ts.  Ir. Mohd Firdaus bin Jalaluddin",
            },
            {
                label: "YBrs. Ts. Ir. Saravanan Subramaniam",
                value: "YBrs. Ts. Ir. Saravanan Subramaniam",
            },
            {
                label: "YBrs. Ts.  Ir. Mohd Lutfi bin Mahali",
                value: "YBrs. Ts.  Ir. Mohd Lutfi bin Mahali",
            },
            {
                label: "YBrs. Ts. Nithiyarajan Masilamany",
                value: "YBrs. Ts. Nithiyarajan Masilamany",
            },
            {
                label: "YBrs. Ts. Eizzuddin bin Nawawi",
                value: "YBrs. Ts. Eizzuddin bin Nawawi",
            },
            {
                label: "YBrs. Ts.  Ir. Muhammad Izzat bin Idris",
                value: "YBrs. Ts.  Ir. Muhammad Izzat bin Idris",
            },
            {
                label: "YBrs. Ts.  Ir. Nor Azery bin Abd Rahim",
                value: "YBrs. Ts.  Ir. Nor Azery bin Abd Rahim",
            },
            {
                label: "YBrs. Ts. Rodhiah binti Murad",
                value: "YBrs. Ts. Rodhiah binti Murad",
            },
            {
                label: "YBrs. Ts. Juhaimy bin Harun",
                value: "YBrs. Ts. Juhaimy bin Harun",
            },
            {
                label: "YBrs. Ts. Dr. Noraimi bin Shafie",
                value: "YBrs. Ts. Dr. Noraimi bin Shafie",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Faizul bin Md Idros",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Faizul bin Md Idros",
            },
            {
                label: "YBrs. Ts. Dr. Hashimah binti Hashim",
                value: "YBrs. Ts. Dr. Hashimah binti Hashim",
            },
            {
                label: "YBrs. Ts.Mohd Muzaffar bin Zahar",
                value: "YBrs. Ts.Mohd Muzaffar bin Zahar",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Ir. Dr. Rosemizi bin Abd Rahim",
                value: "YBrs. Prof. Madya. Ts. Ir. Dr. Rosemizi bin Abd Rahim",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Shafriza Nisha bin Basah",
                value: "YBrs. Prof. Madya Ts. Dr. Shafriza Nisha bin Basah",
            },
            {
                label: "YBrs. Ts. Rhoma Erma bin Zaini",
                value: "YBrs. Ts. Rhoma Erma bin Zaini",
            },
            {
                label: "YBrs. Ts. Ir. Uda bin Sarimin ",
                value: "YBrs. Ts. Ir. Uda bin Sarimin ",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Hairol bin Jaffar",
                value: "YBrs. Ts. Ir. Dr. Hairol bin Jaffar",
            },
            {
                label: "YBrs. Tc. Anuar bin Rozalley",
                value: "YBrs. Tc. Anuar bin Rozalley",
            },
            {
                label: "YBrs. Ts. Raja Muhammed bin Raja Daud",
                value: "YBrs. Ts. Raja Muhammed bin Raja Daud",
            },
            {
                label: "YBrs. Ts. Dr. Amran bin Mohamad Nayan",
                value: "YBrs. Ts. Dr. Amran bin Mohamad Nayan",
            },
            {
                label: "YBrs. Ts. Ahmad Aftas bin Azman",
                value: "YBrs. Ts. Ahmad Aftas bin Azman",
            },
            {
                label: "YBrs. Ts. Ridzuan bin Md. Sham",
                value: "YBrs. Ts. Ridzuan bin Md. Sham",
            },
            {
                label: "YBrs. Ts. Shum Wai Koon",
                value: "YBrs. Ts. Shum Wai Koon",
            },
            {
                label: "YBrs. Ts. Elman bin Mustafa El Bakri",
                value: "YBrs. Ts. Elman bin Mustafa El Bakri",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Jasmy bin Yunus",
                value: "YBrs. Prof. Ts. Dr. Jasmy bin Yunus",
            },
            {
                label: "YBrs. Ts. Hafsah binti Zabidi",
                value: "YBrs. Ts. Hafsah binti Zabidi",
            },
            {
                label: "YBrs. Ts. Ir. Lau Yew Nen",
                value: "YBrs. Ts. Ir. Lau Yew Nen",
            },
            {
                label: "YBrs. Ts. Mohd Khairul Naziri bin Abdul Nashir",
                value: "YBrs. Ts. Mohd Khairul Naziri bin Abdul Nashir",
            },
            {
                label: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
                value: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Ismifaizul bin Mohd Ismail",
                value: "YBrs. Ts. Dr. Mohd Ismifaizul bin Mohd Ismail",
            },
            {
                label: "YBrs. Ts. Aidil Shafiza bin Safiee",
                value: "YBrs. Ts. Aidil Shafiza bin Safiee",
            }
        ],
    },
    {
        label: "Food technology (FT)",
        value: 11,
        sub_fields: [
            {
                label: "Food Processing",
                value: 1,
            },
            {
                label: "Food Science",
                value: 2,
            },
            {
                label: "Food Quality Assurance",
                value: 3,
            },
            {
                label: "Food Bioprocess",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Ts. Dr. Mohamad Yusof bin Maskat",
                value: "YBrs. Prof. Ts. Dr. Mohamad Yusof bin Maskat",
            },
            {
                label: "YBrs. Ts. Roshita binti Ibrahim",
                value: "YBrs. Ts. Roshita binti Ibrahim",
            },
            {
                label: "YBrs. Ts. Dr. Maryana binti Mohamad Nor",
                value: "YBrs. Ts. Dr. Maryana binti Mohamad Nor",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Amiza binti Mat Amin",
                value: "YBrs. Prof. Ts. Dr. Amiza binti Mat Amin",
            },
            {
                label: "YBrs. Ts. Nurul Ain binti Radin",
                value: "YBrs. Ts. Nurul Ain binti Radin",
            },
            {
                label: "YBrs. Ts. Mohd Syafarim bin Md Ishak",
                value: "YBrs. Ts. Mohd Syafarim bin Md Ishak",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Nazri bin Abdul Rahman",
                value: "YBrs. Ts. Dr. Mohd Nazri bin Abdul Rahman",
            },
            {
                label: "YBrs. Ts. Hong Lee Min",
                value: "YBrs. Ts. Hong Lee Min",
            },
            {
                label: "YBrs. Ts. Noraini binti Ab Wahab",
                value: "YBrs. Ts. Noraini binti Ab Wahab",
            },
            {
                label: "YBrs. Ts. Yuganes a/p M Chandran",
                value: "YBrs. Ts. Yuganes a/p M Chandran",
            },
            {
                label: "YBrs. Ts. Farah binti Abu Bakar",
                value: "YBrs. Ts. Farah binti Abu Bakar",
            }
        ],
    },
    {
        label: "Green technology (GT)",
        value: 12,
        sub_fields: [
            {
                label: "Clean Energy",
                value: 1,
            },
            {
                label: "Green Building and Construction",
                value: 2,
            },
            {
                label: "Water and Waste Management",
                value: 3,
            },
            {
                label: "Clean Transportation",
                value: 4,
            },
            {
                label: "Sustainable materials and Manufacturing",
                value: 5,
            },
            {
                label: "Eco forestry and Agriculture",
                value: 6,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Madya Ts. Dr. Hj. Rafidah binti Hamdan",
                value: "YBrs. Prof. Madya Ts. Dr. Hj. Rafidah binti Hamdan",
            },
            {
                label: "YBrs. Ts. Dr. Siti Birkha binti Mohd Ali",
                value: "YBrs. Ts. Dr. Siti Birkha binti Mohd Ali",
            },
            {
                label: "YBrs. Ts. Dr. Sabariah binti Musa",
                value: "YBrs. Ts. Dr. Sabariah binti Musa",
            },
            {
                label: "YBrs. Ts. Dr. Siti Hartini binti Hamdan",
                value: "YBrs. Ts. Dr. Siti Hartini binti Hamdan",
            },
            {
                label: "YBrs. Ts. Dr. Roslaili binti Abdul Aziz",
                value: "YBrs. Ts. Dr. Roslaili binti Abdul Aziz",
            },
            {
                label: "YBrs. Ts. Dr. Hassan bin Mohamed",
                value: "YBrs. Ts. Dr. Hassan bin Mohamed",
            },
            {
                label: "YBrs. Ts. Ir. Muhammad Syukri Imran bin Abdullah",
                value: "YBrs. Ts. Ir. Muhammad Syukri Imran bin Abdullah",
            },
            {
                label: "YBrs. Ts. Mohd Zulhafiz bin Mohd Yajid",
                value: "YBrs. Ts. Mohd Zulhafiz bin Mohd Yajid",
            },
            {
                label: "YBrs. EUR ING Ir.Ts. Ganesh Rao Nagiah",
                value: "YBrs. EUR ING Ir.Ts. Ganesh Rao Nagiah",
            },
            {
                label: "YBrs. Ts. Farhan Farid bin Ahmad Azam",
                value: "YBrs. Ts. Farhan Farid bin Ahmad Azam",
            },
            {
                label: "YBrs. Ts. Mohd Hasamizi bin Mustapa",
                value: "YBrs. Ts. Mohd Hasamizi bin Mustapa",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Sulzakimin bin Mohamed",
                value: "YBrs. Prof. Madya Ts. Dr. Sulzakimin bin Mohamed",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Khairolden bin Ghani",
                value: "YBrs. Ts. Dr. Mohd Khairolden bin Ghani",
            },
            {
                label: "YBrs. Ts. Mohamad Firdaus bin Ibrahim",
                value: "YBrs. Ts. Mohamad Firdaus bin Ibrahim",
            },
            {
                label: "YBrs. Ts. Dr. Haris Fazilah bin Hassan",
                value: "YBrs. Ts. Dr. Haris Fazilah bin Hassan",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
                value: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
            },
            {
                label: "YBrs. Ts. Dr. Siti Noor Hidayah binti Mustapha",
                value: "YBrs. Ts. Dr. Siti Noor Hidayah binti Mustapha",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Muammar bin Mohamad Isa",
                value: "YBrs. Prof. Madya Ts. Dr. Muammar bin Mohamad Isa",
            },
            {
                label: "YBrs. Ts. Dr. Luqman bin Musa",
                value: "YBrs. Ts. Dr. Luqman bin Musa",
            },
            {
                label: "YBrs. Ts. Hoo Mow Heng",
                value: "YBrs. Ts. Hoo Mow Heng",
            },
            {
                label: "YBrs. Ts. Dr. Segar Rajamanickam",
                value: "YBrs. Ts. Dr. Segar Rajamanickam",
            },
            {
                label: "YBrs. Ts. Ir. Saravanan Subramaniam",
                value: "YBrs. Ts. Ir. Saravanan Subramaniam",
            },
            {
                label: "YBrs. Ts. Ir. Muhammad Izzat bin Idris",
                value: "YBrs. Ts. Ir. Muhammad Izzat bin Idris",
            },
            {
                label: "YBrs. Ts. Ida Liyani binti Ahmad",
                value: "YBrs. Ts. Ida Liyani binti Ahmad",
            },
            {
                label: "YBhg. Dato' Ts. Dr. Jaafar bin Abdullah",
                value: "YBhg. Dato' Ts. Dr. Jaafar bin Abdullah",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
            },
            {
                label: "YBrs. Tc. Kamarul Azman bin Mohd Ikram",
                value: "YBrs. Tc. Kamarul Azman bin Mohd Ikram",
            },
            {
                label: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
                value: "YBrs. Ts. Mohamad Tharmizi bin Mohamad Ehsan",
            }
        ],
    },
    {
        label: "Health & medical technology (HM)",
        value: 13,
        sub_fields: [
            {
                label: "Medical Equipment",
                value: 1,
            },
            {
                label: "Medical ICT",
                value: 2,
            },
            {
                label: "Healthcare Facilities",
                value: 3,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
                value: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
            },
            {
                label: "YBrs. Ts. Elman bin Mustafa El Bakri",
                value: "YBrs. Ts. Elman bin Mustafa El Bakri",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Jasmy bin Yunus",
                value: "YBrs. Prof. Ts. Dr. Jasmy bin Yunus",
            },
            {
                label: "YBrs. Ts. Dr. Zulkifli bin Mahmoodin",
                value: "YBrs. Ts. Dr. Zulkifli bin Mahmoodin",
            },
            {
                label: "YBrs. Tc. Mohd Azrin bin Roselan",
                value: "YBrs. Tc. Mohd Azrin bin Roselan",
            },
            {
                label: "YBrs. Ts. Hafsah binti Zabidi",
                value: "YBrs. Ts. Hafsah binti Zabidi",
            },
            {
                label: "YBrs. Ts. Ir. Lau Yew Nen",
                value: "YBrs. Ts. Ir. Lau Yew Nen",
            },
            {
                label: "YBrs. Ts. Aizat bin Abdul Malek",
                value: "YBrs. Ts. Aizat bin Abdul Malek",
            },
            {
                label: "YBrs. Ts. Ahmad Faisal bin Ahmad Basri",
                value: "YBrs. Ts. Ahmad Faisal bin Ahmad Basri",
            },
            {
                label: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
                value: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
            },
            {
                label: "YBrs. Ts. Dr. Muhammad Ikhwan bin Zamhuri",
                value: "YBrs. Ts. Dr. Muhammad Ikhwan bin Zamhuri",
            },
            {
                label: "YBrs. Ts. Dr. Chong Teck Hong",
                value: "YBrs. Ts. Dr. Chong Teck Hong",
            },
            {
                label: "YBrs. Ts. Dr. A Angeli A/P Ambayya @ Ampiah",
                value: "YBrs. Ts. Dr. A Angeli A/P Ambayya @ Ampiah",
            }
        ]
    },
    {
        label: "Information & communication Technology (IT)",
        value: 14,
        sub_fields: [
            {
                label: "ICT Strategic Management",
                value: 1,
            },
            {
                label: "Information & Data Strategy",
                value: 2,
            },
            {
                label: "Information Security Management",
                value: 3,
            },
            {
                label: "ICT Project Management",
                value: 4,
            },
            {
                label: "ICT Infrastructure Management",
                value: 5,
            },
            {
                label: "System Development",
                value: 6,
            },
            {
                label: "Software Testing & Quality Assurance",
                value: 7,
            },
        ],
        panelist: [
                {
                    label: "YBrs. Ts. Wan Azdi bin Wan Omar",
                    value: "YBrs. Ts. Wan Azdi bin Wan Omar",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Nik Zulkarnaen bin Khidzir",
                    value: "YBrs. Prof. Madya Ts. Dr. Nik Zulkarnaen bin Khidzir",
                },
                {
                    label: "YBrs. Ts. Shahrul Niza bin Samsudin",
                    value: "YBrs. Ts. Shahrul Niza bin Samsudin",
                },
                {
                    label: "YBrs. Ts. Shum Wai Koon",
                    value: "YBrs. Ts. Shum Wai Koon",
                },
                {
                    label: "YBrs. Ts. Dr. Suzana binti Basaruddin",
                    value: "YBrs. Ts. Dr. Suzana binti Basaruddin",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Hamimah binti Ujir",
                    value: "YBrs. Prof. Madya Ts. Dr. Hamimah binti Ujir",
                },
                {
                    label: "YBhg. Datin Dr. Ts. Siti Hanom binti Marjuni",
                    value: "YBhg. Datin Dr. Ts. Siti Hanom binti Marjuni",
                },
                {
                    label: "YBrs. Ts. Ir. Zamrin bin Md Zin",
                    value: "YBrs. Ts. Ir. Zamrin bin Md Zin",
                },
                {
                    label: "YBrs. Ts. Nor Paezah binti Abdullah",
                    value: "YBrs. Ts. Nor Paezah binti Abdullah",
                },
                {
                    label: "YBrs. Ts. Dr. Soong Cai Juan",
                    value: "YBrs. Ts. Dr. Soong Cai Juan",
                },
                {
                    label: "YBrs. Ts. Ir. Abdullah bin Ramli",
                    value: "YBrs. Ts. Ir. Abdullah bin Ramli",
                },
                {
                    label: "YBrs. Prof. Madya. Ts. Dr. Noraini binti Seman",
                    value: "YBrs. Prof. Madya. Ts. Dr. Noraini binti Seman",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Dayang NurFatimah binti Awang Iskandar",
                    value: "YBrs. Prof. Madya Ts. Dr. Dayang NurFatimah binti Awang Iskandar",
                },
                {
                    label: "YBrs. Ts. Masrulehsan bin Mamat",
                    value: "YBrs. Ts. Masrulehsan bin Mamat",
                },
                {
                    label: "YBrs. Prof. Madya. Ts. Dr. Mumtazimah binti Mohamad",
                    value: "YBrs. Prof. Madya. Ts. Dr. Mumtazimah binti Mohamad",
                },
                {
                    label: "YBrs. Ts. Dr. Azliza binti Yacob",
                    value: "YBrs. Ts. Dr. Azliza binti Yacob",
                },
                {
                    label: "YBrs. Ts. Dr. Noor Suhana binti Sulaiman",
                    value: "YBrs. Ts. Dr. Noor Suhana binti Sulaiman",
                },
                {
                    label: "YBrs. Ts. Mohd Yasrin bin Mohd Din",
                    value: "YBrs. Ts. Mohd Yasrin bin Mohd Din",
                },
                {
                    label: "YBrs. Ts. Lee Jian Aun",
                    value: "YBrs. Ts. Lee Jian Aun",
                },
                {
                    label: "YBrs. Insp. Ts. Mohd Norzikri bin Kamaruddin",
                    value: "YBrs. Insp. Ts. Mohd Norzikri bin Kamaruddin",
                },
                {
                    label: "YBrs. Ts. Dr. Nur Sukinah binti Aziz",
                    value: "YBrs. Ts. Dr. Nur Sukinah binti Aziz",
                },
                {
                    label: "YBrs. Ts. Herwan Shah bin Mohamad",
                    value: "YBrs. Ts. Herwan Shah bin Mohamad",
                },
                {
                    label: "YBrs. Ts. Mohammad Firdaus bin Abdul Rahman",
                    value: "YBrs. Ts. Mohammad Firdaus bin Abdul Rahman",
                },
                {
                    label: "YBrs. Ts. Saiful Bakhtiar bin Osman",
                    value: "YBrs. Ts. Saiful Bakhtiar bin Osman",
                },
                {
                    label: "YBrs. Tc. Muhamad Nur Hafiz bin A Rahim",
                    value: "YBrs. Tc. Muhamad Nur Hafiz bin A Rahim",
                },
                {
                    label: "YBrs. Ts. Shashi Muniandy",
                    value: "YBrs. Ts. Shashi Muniandy",
                },
                {
                    label: "YBrs. Ts. A'iniah binti Kamarudin",
                    value: "YBrs. Ts. A'iniah binti Kamarudin",
                },
                {
                    label: "YBrs. Ts. Ridzuan bin Mustafa",
                    value: "YBrs. Ts. Ridzuan bin Mustafa",
                },
                {
                    label: "YBrs. Ts. Tharmaraj Batmanathan",
                    value: "YBrs. Ts. Tharmaraj Batmanathan",
                },
                {
                    label: "YBrs. Ts. Wong Koon Hoong",
                    value: "YBrs. Ts. Wong Koon Hoong",
                },
                {
                    label: "YBrs. Ts. Ediwarman bin Mohamad Taher",
                    value: "YBrs. Ts. Ediwarman bin Mohamad Taher",
                },
                {
                    label: "YBrs. Ts. Ah Faezal Husni bin Arshad",
                    value: "YBrs. Ts. Ah Faezal Husni bin Arshad",
                },
                {
                    label: "YBrs. Ts. Norhasniah binti Ab Aziz",
                    value: "YBrs. Ts. Norhasniah binti Ab Aziz",
                },
                {
                    label: "YBrs. Ts. Desmond Ng Kok Sing",
                    value: "YBrs. Ts. Desmond Ng Kok Sing",
                },
                {
                    label: "YBrs. Ts. Khalil Rahman bin Ameer Khan",
                    value: "YBrs. Ts. Khalil Rahman bin Ameer Khan",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Zulkefli bin Mansor",
                    value: "YBrs. Prof. Madya Ts. Dr. Zulkefli bin Mansor",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Noor Afiza binti Mat Razali",
                    value: "YBrs. Prof. Madya Ts. Dr. Noor Afiza binti Mat Razali",
                },
                {
                    label: "YBrs. Ts. Mohammed Khairil Adzhar bin Mohammed",
                    value: "YBrs. Ts. Mohammed Khairil Adzhar bin Mohammed",
                },
                {
                    label: "YBrs. Ts. Mohd Rizal bin Atan",
                    value: "YBrs. Ts. Mohd Rizal bin Atan",
                },
                {
                    label: "YBrs. Ts. Ahmad Hadinata bin Fauzi",
                    value: "YBrs. Ts. Ahmad Hadinata bin Fauzi",
                },
                {
                    label: "YBrs. Ts. Jaiz Anuar bin Yeop Johari",
                    value: "YBrs. Ts. Jaiz Anuar bin Yeop Johari",
                },
                {
                    label: "YBrs. Ts. Nor Faiz bin Muhammad Noor",
                    value: "YBrs. Ts. Nor Faiz bin Muhammad Noor",
                },
                {
                    label: "YBrs. Ts. Huzaini bin Mohd Noor",
                    value: "YBrs. Ts. Huzaini bin Mohd Noor",
                },
                {
                    label: "YBrs. Ts. Salim bin Mohamad Ghani",
                    value: "YBrs. Ts. Salim bin Mohamad Ghani",
                },
                {
                    label: "YBrs. Ts. Arief Affendi bin Ab Wahab",
                    value: "YBrs. Ts. Arief Affendi bin Ab Wahab",
                },
                {
                    label: "YBrs. Ts. Raja Irwan bin Raja Sahar",
                    value: "YBrs. Ts. Raja Irwan bin Raja Sahar",
                },
                {
                    label: "YBrs. Ts. Elza binti Usman",
                    value: "YBrs. Ts. Elza binti Usman",
                },
                {
                    label: "Tan Foo Chong",
                    value: "Tan Foo Chong",
                },
                {
                    label: "YBrs. Prof. Madya. Ts. Dr. Tan Tse Guan",
                    value: "YBrs. Prof. Madya. Ts. Dr. Tan Tse Guan",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
                    value: "YBrs. Prof. Madya Ts. Dr. Noor Azurati binti Ahmad @ Salleh",
                },
                {
                    label: "YBrs. Ts. Hizal Hanis bin Hashim",
                    value: "YBrs. Ts. Hizal Hanis bin Hashim",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
                    value: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
                },
                {
                    label: "YBrs. Prof. Madya. Ts. Dr. Lim Ean Heng",
                    value: "YBrs. Prof. Madya. Ts. Dr. Lim Ean Heng",
                },
                {
                    label: "YBrs. Ts. Khairul Nadzmi bin Mohd Yusof",
                    value: "YBrs. Ts. Khairul Nadzmi bin Mohd Yusof",
                },
                {
                    label: "YBrs. Ts. Puganeswaran a/l Kannan",
                    value: "YBrs. Ts. Puganeswaran a/l Kannan",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Tan Chin Ike",
                    value: "YBrs. Prof. Madya Ts. Dr. Tan Chin Ike",
                },
                {
                    label: "YBrs. Prof. Madya Ts. Dr. Mohd Faizul bin Md Idros",
                    value: "YBrs. Prof. Madya Ts. Dr. Mohd Faizul bin Md Idros",
                },
                {
                    label: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
                    value: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
                },
                {
                    label: "YBrs. Ts. Mohd Nazri bin Johari",
                    value: "YBrs. Ts. Mohd Nazri bin Johari",
                }
        ],
    },
    {
        label: "Manufacturing & industrial technology (ME)",
        value: 15,
        sub_fields: [
            {
                label: "Industrial and Manufacturing Planning",
                value: 1,
            },
            {
                label: "Design, Development, Simulation and Optimization",
                value: 2,
            },
            {
                label: "Assembly, Disassembly and Packaging",
                value: 3,
            },
            {
                label: "Materials and Manufacturing Processes",
                value: 4,
            },
            {
                label: "Robotic, Automation and Artificial Intelligence",
                value: 5,
            },
            {
                label: "Testing, Commissioning, Metrology and Quality",
                value: 6,
            },
            {
                label: "Technical and Product Support",
                value: 7,
            },
            {
                label: "Operation, Performance, Reliability, and Improvement",
                value: 8,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Ridzuan bin Md. Sham",
                value: "YBrs. Ts. Ridzuan bin Md. Sham",
            },
            {
                label: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
                value: "YBrs. Ts. Dr. Kapten (PA) Khoo Boo Kean",
            },
            {
                label: "YBrs. Ts. Ho Yoong Chow",
                value: "YBrs. Ts. Ho Yoong Chow",
            },
            {
                label: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
                value: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Azmi bin Ahmad",
                value: "YBrs. Ts. Ir. Dr. Azmi bin Ahmad",
            },
            {
                label: "YBrs. Ts. Dr. Luqman bin Musa",
                value: "YBrs. Ts. Dr. Luqman bin Musa",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Adzrie bin Radzali",
                value: "YBrs. Ts. Ir. Mohd Adzrie bin Radzali",
            },
            {
                label: "YBrs. Ts. Amirul bin Sait",
                value: "YBrs. Ts. Amirul bin Sait",
            },
            {
                label: "YBrs. Ts. Jaidil @ Jaiden bin Yakop",
                value: "YBrs. Ts. Jaidil @ Jaiden bin Yakop",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Safian bin Sharif",
                value: "YBrs. Prof. Ts. Dr. Safian bin Sharif",
            },
            {
                label: "YBrs. Ts. Mohamad Fairuz bin Ya'ccob",
                value: "YBrs. Ts. Mohamad Fairuz bin Ya'ccob",
            },
            {
                label: "YBrs. Tc. Mohd Nasirwan bin Mohamad Anas",
                value: "YBrs. Tc. Mohd Nasirwan bin Mohamad Anas",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Elias bin Daud",
                value: "YBrs. Ts. Dr. Mohd Elias bin Daud",
            },
            {
                label: "YBrs. Ts. Mohamad Halim bin Ibrahim",
                value: "YBrs. Ts. Mohamad Halim bin Ibrahim",
            },
            {
                label: "YBrs. Ts. Dr. Choong Chee Guan",
                value: "YBrs. Ts. Dr. Choong Chee Guan",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Che Ghani bin Che Kob",
                value: "YBrs. Prof. Madya Ts. Dr. Che Ghani bin Che Kob",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Nazri bin Omar",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Nazri bin Omar",
            },
            {
                label: "YBrs. Ts. Ameran bin Saiman",
                value: "YBrs. Ts. Ameran bin Saiman",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Solehuddin bin Shuib",
                value: "YBrs. Prof. Ts. Ir. Dr. Solehuddin bin Shuib",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Tan Wei Hong",
                value: "YBrs. Prof. Madya Ts. Dr. Tan Wei Hong",
            },
            {
                label: "YBrs. Ts. Dr. Nur Rashid bin Mat Nuri @ Md Din",
                value: "YBrs. Ts. Dr. Nur Rashid bin Mat Nuri @ Md Din",
            },
            {
                label: "YBrs. Ts. Teoh Thean Hin",
                value: "YBrs. Ts. Teoh Thean Hin",
            },
            {
                label: "YBrs. Ts. Ahmad Khairil bin Abdul Jabar",
                value: "YBrs. Ts. Ahmad Khairil bin Abdul Jabar",
            },
            {
                label: "YBrs. Ts. Dr. Ummu Kulthum binti Jamaludin",
                value: "YBrs. Ts. Dr. Ummu Kulthum binti Jamaludin",
            },
            {
                label: "YBrs. Tc. Mohammad Asrul Nizam bin Mohammad Ridzuan",
                value: "YBrs. Tc. Mohammad Asrul Nizam bin Mohammad Ridzuan",
            },
            {
                label: "YBrs. Ts. Muhamad Jamil bin Mashdar",
                value: "YBrs. Ts. Muhamad Jamil bin Mashdar",
            },
            {
                label: "YBrs. Ts. Asleeda binti Ahmad",
                value: "YBrs. Ts. Asleeda binti Ahmad",
            },
            {
                label: "YBrs. Ts. Abdul Hanif bin Ludin",
                value: "YBrs. Ts. Abdul Hanif bin Ludin",
            },
            {
                label: "YBrs. Ts. Saiful Bahari bin Hamzah",
                value: "YBrs. Ts. Saiful Bahari bin Hamzah",
            },
            {
                label: "YBrs. Ts. Kamaludin bin Tomiran",
                value: "YBrs. Ts. Kamaludin bin Tomiran",
            },
            {
                label: "YBrs. Ts. Mohamad Amirul Nizam bin Mohamed Thari",
                value: "YBrs. Ts. Mohamad Amirul Nizam bin Mohamed Thari",
            },
            {
                label: "YBrs. Ts. Nik Nurul Fatima Azzahra binti Mohd Rosli",
                value: "YBrs. Ts. Nik Nurul Fatima Azzahra binti Mohd Rosli",
            },
            {
                label: "YBrs. Ts. Lee Fu Kang",
                value: "YBrs. Ts. Lee Fu Kang",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Hafez bin Abd Rahman",
                value: "YBrs. Ts. Dr. Mohd Hafez bin Abd Rahman",
            },
            {
                label: "YBrs. Ts. Abd Malik bin Yusof",
                value: "YBrs. Ts. Abd Malik bin Yusof",
            },
            {
                label: "YBrs. Ts. Ir. Br. Noorhazilah binti baharin",
                value: "YBrs. Ts. Ir. Br. Noorhazilah binti baharin",
            },
            {
                label: "YBrs. Eur. Ing. Ts. Hong Wai Onn",
                value: "YBrs. Eur. Ing. Ts. Hong Wai Onn",
            },
            {
                label: "YBrs. Ts. Ir. Gan Kok Yong",
                value: "YBrs. Ts. Ir. Gan Kok Yong",
            },
            {
                label: "YBrs. Ts. Muhammad Irfan bin Abd Razak",
                value: "YBrs. Ts. Muhammad Irfan bin Abd Razak",
            },
            {
                label: "YBrs. Ts. Mohd Khairul Naziri bin Abdul Nashir",
                value: "YBrs. Ts. Mohd Khairul Naziri bin Abdul Nashir",
            },
            {
                label: "YBrs. Ts. Mohd Shahli bin Mohd Shek",
                value: "YBrs. Ts. Mohd Shahli bin Mohd Shek",
            },
            {
                label: "YBrs. Tc. Hafizul Hakim bin Muhid",
                value: "YBrs. Tc. Hafizul Hakim bin Muhid",
            },
            {
                label: "YBrs. Ts. Raja Azwan bin Raja Daud",
                value: "YBrs. Ts. Raja Azwan bin Raja Daud",
            },
            {
                label: "YBrs. Ts. Mohamed Fauzi bin Mohamed Hussain",
                value: "YBrs. Ts. Mohamed Fauzi bin Mohamed Hussain",
            },
            {
                label: "YBrs. Ts. Izatul Hamimi binti Abdul Razak",
                value: "YBrs. Ts. Izatul Hamimi binti Abdul Razak",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Mohamad Ali bin Ahmad",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Mohamad Ali bin Ahmad",
            },
            {
                label: "YBrs. Ts. Kamarul Adnan bin Abd Aziz",
                value: "YBrs. Ts. Kamarul Adnan bin Abd Aziz",
            },
            {
                label: "YBrs. Ts. Dr. Mohammad Taufiq bin Mustaffa",
                value: "YBrs. Ts. Dr. Mohammad Taufiq bin Mustaffa",
            },
            {
                label: "YBrs. Ts. Aidil Shafiza bin Safiee",
                value: "YBrs. Ts. Aidil Shafiza bin Safiee",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Fairuz bin Mohd Rashid",
                value: "YBrs. Ts. Ir. Mohd Fairuz bin Mohd Rashid",
            },
            {
                label: "YBrs. Ts. Dr. George Decruz",
                value: "YBrs. Ts. Dr. George Decruz",
            },
            {
                label: "YBrs. Ts. Ir. Saifuladili bin Jaafar",
                value: "YBrs. Ts. Ir. Saifuladili bin Jaafar",
            },
            {
                label: "YBrs. Ts. Zamzul Khairi bin Zulkifli",
                value: "YBrs. Ts. Zamzul Khairi bin Zulkifli",
            },
            {
                label: "YBrs. Ts. Ir. Kapten (B) Mohamad Fariz bin Mohamed Nasir",
                value: "YBrs. Ts. Ir. Kapten (B) Mohamad Fariz bin Mohamed Nasir",
            },
            {
                label: "YBrs. Ts. Asmira bin Ashari ",
                value: "YBrs. Ts. Asmira bin Ashari ",
            },
            {
                label: "YBrs. Ts. Dr. Nora binti Osman",
                value: "YBrs. Ts. Dr. Nora binti Osman",
            },
            {
                label: "YBrs. Tc. Sapian bin Ishak",
                value: "YBrs. Tc. Sapian bin Ishak",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Hamisa bin Abdul Hamid",
                value: "YBrs. Ts. Dr. Mohd Hamisa bin Abdul Hamid",
            },
            {
                label: "YBrs. Ts. Nurin Ilyani binti Khamis",
                value: "YBrs. Ts. Nurin Ilyani binti Khamis",
            },
            {
                label: "YBrs. Ts. Ahmad Muzafar bin Mamat @ Adam",
                value: "YBrs. Ts. Ahmad Muzafar bin Mamat @ Adam",
            },
            {
                label: "YBrs. Ts. Mohd Rafis bin Mohamed",
                value: "YBrs. Ts. Mohd Rafis bin Mohamed",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Khairur Rijal bin Jamaludin",
                value: "YBrs. Prof. Ts. Dr. Khairur Rijal bin Jamaludin",
            },
            {
                label: "YBrs. Ts. Dr. Hasyamuddin bin Othman",
                value: "YBrs. Ts. Dr. Hasyamuddin bin Othman",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
                value: "YBrs. Prof. Madya Ts. Dr. Abdul Halim bin Abdullah",
            },
            {
                label: "YBrs. Ts. Dr. Siti Hartini binti Hamdan",
                value: "YBrs. Ts. Dr. Siti Hartini binti Hamdan",
            },
            {
                label: "YBrs. Ts. Dr. Mohamad Annuar Assadat bin Husain",
                value: "YBrs. Ts. Dr. Mohamad Annuar Assadat bin Husain",
            },
            {
                label: "YBrs. Ts. Abdul Halim bin Abd Rahman",
                value: "YBrs. Ts. Abdul Halim bin Abd Rahman",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Mohd Ruzaimi bin Mat Rejab",
                value: "YBrs. Prof. Ts. Dr. Mohd Ruzaimi bin Mat Rejab",
            },
            {
                label: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
                value: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
            },
            {
                label: "YBrs. Ts. Adlan Akram bin Mohamad Mazuki",
                value: "YBrs. Ts. Adlan Akram bin Mohamad Mazuki",
            },
            {
                label: "YBrs. Ts. Mohammad Al Bukhari bin Marzuki",
                value: "YBrs. Ts. Mohammad Al Bukhari bin Marzuki",
            },
            {
                label: "YBrs. Ts. Mohd Hazwan bin Mohamed Norli",
                value: "YBrs. Ts. Mohd Hazwan bin Mohamed Norli",
            },
            {
                label: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
                value: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
            },
            {
                label: "YBrs. Ts. Dr. Amran bin Mohamad Nayan",
                value: "YBrs. Ts. Dr. Amran bin Mohamad Nayan",
            },
            {
                label: "YBrs. Tc. Mohd Husaini bin Seman",
                value: "YBrs. Tc. Mohd Husaini bin Seman",
            },
            {
                label: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
                value: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
            }
        ],
    },
    {
        label: "Marine technology (MR)",
        value: 16,
        sub_fields: [
            {
                label: "Fisheries",
                value: 1,
            },
            {
                label: "Aquaculture",
                value: 2,
            },
            {
                label: "Conservation",
                value: 3,
            },
            {
                label: "Exploration",
                value: 4,
            },
            {
                label: "Pollution",
                value: 5,
            },
            {
                label: "Eco-system",
                value: 6,
            },
            {
                label: "Oceanography",
                value: 7,
            },
            {
                label: "Oceanology",
                value: 8,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Saiful Bahri bin Hamzah",
                value: "YBrs. Ts. Saiful Bahri bin Hamzah",
            },
            {
                label: "YBrs. Ts. Mohd Naim bin Awang",
                value: "YBrs. Ts. Mohd Naim bin Awang",
            },
            {
                label: "YBrs. Ts. Zakiman bin Zali",
                value: "YBrs. Ts. Zakiman bin Zali",
            },
            {
                label: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
                value: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
            },
            {
                label: "YBrs. Lt. Cdr. (B) Ts. Mohd Zulhilmi bin Jamaluddin",
                value: "YBrs. Lt. Cdr. (B) Ts. Mohd Zulhilmi bin Jamaluddin",
            }
        ],
    },
    {
        label: "Maritime technology (MI)",
        value: 17,
        sub_fields: [
            {
                label: "Seafaring",
                value: 1,
            },
            {
                label: "Navigation",
                value: 2,
            },
            {
                label: "Seamanship",
                value: 3,
            },
            {
                label: "Marine Engineering",
                value: 4,
            },
            {
                label: "Cargo",
                value: 5,
            },
            {
                label: "Ship",
                value: 6,
            },
            {
                label: "Boats",
                value: 7,
            },
            {
                label: "Oil rigs",
                value: 8,
            },
            {
                label: "Ports",
                value: 9,
            },
            {
                label: "Submersible",
                value: 10,
            },
        ],
        panelist: [
            {
                label: "YBrs. Lt. Cdr. (B) Ts. Mohd Zulhilmi bin Jamaluddin",
                value: "YBrs. Lt. Cdr. (B) Ts. Mohd Zulhilmi bin Jamaluddin",
            },
            {
                label: "YBrs. Capt. Ts. Mohd Awiskarni bin Shamsudin",
                value: "YBrs. Capt. Ts. Mohd Awiskarni bin Shamsudin",
            },
            {
                label: "YBrs. Ts. Ir.Roznan bin Abdul Rashid",
                value: "YBrs. Ts. Ir.Roznan bin Abdul Rashid",
            },
            {
                label: "YBrs. Ts. Mohd Nazri bin Johari",
                value: "YBrs. Ts. Mohd Nazri bin Johari",
            },
            {
                label: "YBrs. Tc. Khairul Anwar bin Mohd Nor",
                value: "YBrs. Tc. Khairul Anwar bin Mohd Nor",
            },
            {
                label: "YBrs. Ts. S.Veerakumar A/L S.Subramaniam",
                value: "YBrs. Ts. S.Veerakumar A/L S.Subramaniam",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Md Redzuan bin Zoolfakar",
                value: "YBrs. Prof. Madya Ts. Dr. Md Redzuan bin Zoolfakar",
            },
            {
                label: "YBrs. Ts. Ir. Hazrool Rizal bin Abdul Rahim",
                value: "YBrs. Ts. Ir. Hazrool Rizal bin Abdul Rahim",
            },
            {
                label: "YBrs. Ts. Kapten Mohd Yusrino bin Taib",
                value: "YBrs. Ts. Kapten Mohd Yusrino bin Taib",
            },
            {
                label: "YBrs. Ts. Muhammad Fadhli bin Makhtar",
                value: "YBrs. Ts. Muhammad Fadhli bin Makhtar",
            },
            {
                label: "YBrs. Ts. Dr. Kapten Amir Syawal bin Kamis",
                value: "YBrs. Ts. Dr. Kapten Amir Syawal bin Kamis",
            },
            {
                label: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
                value: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
            },
            {
                label: "YBrs. Ts. Mohd Naim bin Awang",
                value: "YBrs. Ts. Mohd Naim bin Awang",
            },
            {
                label: "YBrs. Ts. Dr. Julyus Melvin Mobilik",
                value: "YBrs. Ts. Dr. Julyus Melvin Mobilik",
            },
            {
                label: "YBrs. Ts. Zakiman bin Zali",
                value: "YBrs. Ts. Zakiman bin Zali",
            },
            {
                label: "YBrs. Ts. Ir. Uda bin Sarimin ",
                value: "YBrs. Ts. Ir. Uda bin Sarimin ",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Kasypi bin Mokhtar",
                value: "YBrs. Prof. Madya Ts. Dr. Kasypi bin Mokhtar",
            }
        ],
    },
    {
        label: "Material science technology (MT)",
        value: 18,
        sub_fields: [
            {
                label: "Metal",
                value: 1,
            },
            {
                label: "Ceramic",
                value: 2,
            },
            {
                label: "Polymer",
                value: 3,
            },
            {
                label: "Composite",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Zuhailawati binti Hussain",
                value: "YBrs. Prof. Ts. Ir. Dr. Zuhailawati binti Hussain",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Hasmaliza Mohamad",
                value: "YBrs. Prof. Ts. Dr. Hasmaliza Mohamad",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Zuratul Ain binti Abdul Hamid",
                value: "YBrs. Prof. Madya Ts. Dr. Zuratul Ain binti Abdul Hamid",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Pung Swee Yong",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Pung Swee Yong",
            },
            {
                label: "YBrs. Tc. Suria Adam bin Daneil Tomo",
                value: "YBrs. Tc. Suria Adam bin Daneil Tomo",
            },
            {
                label: "YBrs. Ts. Mohd Shairul bin Harun",
                value: "YBrs. Ts. Mohd Shairul bin Harun",
            },
            {
                label: "YBrs. Ts. Dr. Siti Noor Hidayah binti Mustapha",
                value: "YBrs. Ts. Dr. Siti Noor Hidayah binti Mustapha",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Mohd Firdaus bin Omar",
            },
            {
                label: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
                value: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Khor Shing Fhan",
                value: "YBrs. Prof. Madya Ts. Dr. Khor Shing Fhan",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Dr. Nor Hakimin bin Abdullah",
                value: "YBrs. Prof. Madya. Ts. Dr. Nor Hakimin bin Abdullah",
            },
            {
                label: "YBrs. Ts. Adlan Akram bin Mohamad Mazuki",
                value: "YBrs. Ts. Adlan Akram bin Mohamad Mazuki",
            },
            {
                label: "YBrs. Ts. ChM. Dr. Yeoh Beng Hoong",
                value: "YBrs. Ts. ChM. Dr. Yeoh Beng Hoong",
            },
            {
                label: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
                value: "YBrs. Ts. Dr. Ahmad Azrem bin Azmi",
            },
            {
                label: "YBrs. Ts. Dr. Wan Mohd Arif bin W. Ibrahim",
                value: "YBrs. Ts. Dr. Wan Mohd Arif bin W. Ibrahim",
            },
            {
                label: "YBrs. Ts. Dr. Alina binti A Rahman @ Othman",
                value: "YBrs. Ts. Dr. Alina binti A Rahman @ Othman",
            },
            {
                label: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
                value: "YBhg. Datin Dr. Ts. Norsaadah binti Zakaria ",
            },
            {
                label: "YBrs. Ts. Dr. Haryati binti Yaacob",
                value: "YBrs. Ts. Dr. Haryati binti Yaacob",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
                value: "YBrs. Prof. Madya Ts. Dr. Salmiaton binti Ali",
            },
            {
                label: "YBrs. Ts. Dr. Luqman bin Musa",
                value: "YBrs. Ts. Dr. Luqman bin Musa",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
                value: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
            },
            {
                label: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
                value: "YBrs. Ts. Ir. Gs. Br. PMr. Azrol bin Jailani",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
                value: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
            },
            {
                label: "YBrs. Ts. Che Rahmat bin Che Mat",
                value: "YBrs. Ts. Che Rahmat bin Che Mat",
            }
        ],
    },
    {
        label: "Nanotechnology (NT)",
        value: 19,
        sub_fields: [
            {
                label: "Semiconductor",
                value: 1,
            },
            {
                label: "Surface Science",
                value: 2,
            },
            {
                label: "Microfabrication",
                value: 3,
            },
            {
                label: "Molecular Technology",
                value: 4,
            },
            {
                label: "Nano medicine",
                value: 5,
            },
            {
                label: "Nano Electronics",
                value: 6,
            },
            {
                label: "Energy",
                value: 7,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Ir. Dr. Mohamad Hafiz bin Mamat",
                value: "YBrs. Ts. Ir. Dr. Mohamad Hafiz bin Mamat",
            },
            {
                label: "YBrs. Ts. Dr. Amir Syahir bin Amir Hamzah",
                value: "YBrs. Ts. Dr. Amir Syahir bin Amir Hamzah",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Pung Swee Yong",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Pung Swee Yong",
            },
            {
                label: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
                value: "YBhg. Prof. Datuk Ts. Dr. Abdul Khalil bin Shawkataly",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
                value: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
            }
        ]
    },
    {
        label: "Nuclear & radiological technology (NR)",
        value: 20,
        sub_fields: [
            {
                label: "Ionizing",
                value: 1,
            },
            {
                label: "Non-ionizing",
                value: 2,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Nordin bin Ayoub",
                value: "YBrs. Ts. Nordin bin Ayoub",
            },
            {
                label: "YBrs. Ts. Dr. Mohamad Annuar Assadat bin Husain",
                value: "YBrs. Ts. Dr. Mohamad Annuar Assadat bin Husain",
            },
            {
                label: "YBrs. Tc. Nur Aiman bin Baharuddin",
                value: "YBrs. Tc. Nur Aiman bin Baharuddin",
            },
            {
                label: "YBrs. Ts. Dr. Ahmad Hussein bin Abdul Hamid",
                value: "YBrs. Ts. Dr. Ahmad Hussein bin Abdul Hamid",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Amirul Syafiq bin Mohd Yunos",
                value: "YBrs. Ts. Dr. Mohd Amirul Syafiq bin Mohd Yunos",
            },
            {
                label: "YBrs. Ts. Dr. Chong Teck Hong",
                value: "YBrs. Ts. Dr. Chong Teck Hong",
            },
            {
                label: "YBhg. Dato' Ts. Dr. Jaafar bin Abdullah",
                value: "YBhg. Dato' Ts. Dr. Jaafar bin Abdullah",
            },
            {
                label: "YBrs. Ts. Dr. Hassan bin Mohamed",
                value: "YBrs. Ts. Dr. Hassan bin Mohamed",
            }
         ]
    },
    {
        label: "Oil & gas technology (OG)",
        value: 21,
        sub_fields: [
            {
                label: "Exploration and Production",
                value: 1,
            },
            {
                label: "Chemical Process and Product",
                value: 2,
            },
            {
                label: "Logistics Oil and Gas",
                value: 3,
            },
            {
                label: "Energy and Utilities",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts.Syahrul bin Manap",
                value: "YBrs. Ts.Syahrul bin Manap",
            },
            {
                label: "YBrs. Ts. Mohd Rosmaini bin Shaari",
                value: "YBrs. Ts. Mohd Rosmaini bin Shaari",
            },
            {
                label: "YBrs. Ts. Ir. Hj. Akbal bin Abu",
                value: "YBrs. Ts. Ir. Hj. Akbal bin Abu",
            },
            {
                label: "YBrs. Ts. Ir. Hj. Muhamad Sahir bin Shatiry",
                value: "YBrs. Ts. Ir. Hj. Muhamad Sahir bin Shatiry",
            },
            {
                label: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
                value: "YBrs. Ts. Ir. Azlan bin Abu Bakar",
            },
            {
                label: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
                value: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
            },
            {
                label: "YBrs. Ts. Ir. Mohd Amir Fikri bin Basri",
                value: "YBrs. Ts. Ir. Mohd Amir Fikri bin Basri",
            },
            {
                label: "YBrs. Ts. Ir. Khairan Syuhada binti Kassim",
                value: "YBrs. Ts. Ir. Khairan Syuhada binti Kassim",
            },
            {
                label: "YBrs. Ts. Ir. Mohamad Ridzuan bin Sani",
                value: "YBrs. Ts. Ir. Mohamad Ridzuan bin Sani",
            },
            {
                label: "YBrs. Ts. Haikal bin Zulkifli",
                value: "YBrs. Ts. Haikal bin Zulkifli",
            },
            {
                label: "YBrs. Ts. Mohammad Fadhli bin Yaakob",
                value: "YBrs. Ts. Mohammad Fadhli bin Yaakob",
            },
            {
                label: "YBrs. Ts. Syahril Rafieq bin Abd Manab",
                value: "YBrs. Ts. Syahril Rafieq bin Abd Manab",
            },
            {
                label: "YBrs. Ts. Ir. Rafiuddin bin Abdubrani",
                value: "YBrs. Ts. Ir. Rafiuddin bin Abdubrani",
            },
            {
                label: "YBrs. Ts.  Ir. Mohd Razmi Ziqri bin Ahmad Shukri",
                value: "YBrs. Ts.  Ir. Mohd Razmi Ziqri bin Ahmad Shukri",
            },
            {
                label: "YBrs. Ts.  Ir. Muhd Aiman Afiq bin Abu Bakar",
                value: "YBrs. Ts.  Ir. Muhd Aiman Afiq bin Abu Bakar",
            },
            {
                label: "YBrs. Ts. Arif Azhan bin Abdul Manap @ A. Manaf",
                value: "YBrs. Ts. Arif Azhan bin Abdul Manap @ A. Manaf",
            },
            {
                label: "YBrs. Ts. Sivakumar Nadaraja",
                value: "YBrs. Ts. Sivakumar Nadaraja",
            },
            {
                label: "YBrs. Ts. Ir. Zul Hazran bin Husni",
                value: "YBrs. Ts. Ir. Zul Hazran bin Husni",
            },
            {
                label: "YBrs. Ts. Norfalisa binti Jusoh",
                value: "YBrs. Ts. Norfalisa binti Jusoh",
            },
            {
                label: "YBrs. Ts. Ahmad Azlan bin Ahmad Adlan",
                value: "YBrs. Ts. Ahmad Azlan bin Ahmad Adlan",
            },
            {
                label: "YBrs. Ts. Ruslan bin Md Saleh",
                value: "YBrs. Ts. Ruslan bin Md Saleh",
            },
            {
                label: "YBrs. Ts. Mohd Faizal bin Ghazali",
                value: "YBrs. Ts. Mohd Faizal bin Ghazali",
            },
            {
                label: "YBrs. Ts. Ir. Noor Hisham bin Yahaya",
                value: "YBrs. Ts. Ir. Noor Hisham bin Yahaya",
            },
            {
                label: "YBhg. Prof. Ts. Ir. Dr. Zainal bin Zakaria",
                value: "YBhg. Prof. Ts. Ir. Dr. Zainal bin Zakaria",
            },
            {
                label: "YBrs. Ts. Ng Wei Khiang",
                value: "YBrs. Ts. Ng Wei Khiang",
            },
            {
                label: "YBrs. Ts. Mujahidah Sholihah binti Hj Rosli",
                value: "YBrs. Ts. Mujahidah Sholihah binti Hj Rosli",
            },
            {
                label: "YBrs. Ts. Mohd Riduan bin Abdullah",
                value: "YBrs. Ts. Mohd Riduan bin Abdullah",
            },
            {
                label: "YBrs. Ts. Mohd Abd Fatah bin Mohd Ramly",
                value: "YBrs. Ts. Mohd Abd Fatah bin Mohd Ramly",
            },
            {
                label: "YBrs. Ts. Mohamad Hasrizal bin Mat Isa",
                value: "YBrs. Ts. Mohamad Hasrizal bin Mat Isa",
            },
            {
                label: "YBrs. Ts. Musreen Azwan in Mustafa",
                value: "YBrs. Ts. Musreen Azwan in Mustafa",
            },
            {
                label: "YBrs. Ts. Zahiruddin Shah bin Abdul Jalal",
                value: "YBrs. Ts. Zahiruddin Shah bin Abdul Jalal",
            },
            {
                label: "YBrs. Tc. Muhammad Fudhail bin Abd Rahman",
                value: "YBrs. Tc. Muhammad Fudhail bin Abd Rahman",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Nazri bin Omar",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Nazri bin Omar",
            },
            {
                label: "YBrs. Ts. Dr. Wan Mohd Arif bin W. Ibrahim",
                value: "YBrs. Ts. Dr. Wan Mohd Arif bin W. Ibrahim",
            }
        ]
    },
    {
        label: "Resource based, survey and geomatics technology (RB)",
        value: 22,
        sub_fields: [
            {
                label: "Geographic Information System (GIS)",
                value: 1,
            },
            {
                label: "Remote Sensing",
                value: 2,
            },
            {
                label: "Land Survey",
                value: 3,
            },
            {
                label: "Mineral",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Dr. Kelvin Tang Kang Wee",
                value: "YBrs. Ts. Dr. Kelvin Tang Kang Wee",
            },
            {
                label: "YBrs. Lt. Kdr. Prof. Ts. Gs. Dr. Mohd Hasmadi bin Ismail ",
                value: "YBrs. Lt. Kdr. Prof. Ts. Gs. Dr. Mohd Hasmadi bin Ismail ",
            },
            {
                label: "YBhg. Prof. Dato' Ts. Ir. Dr. Eric Goh Kok Hoe",
                value: "YBhg. Prof. Dato' Ts. Ir. Dr. Eric Goh Kok Hoe",
            },
            {
                label: "YBrs. Ts. Sr. Gs. Rizatulazri bin Idris",
                value: "YBrs. Ts. Sr. Gs. Rizatulazri bin Idris",
            },
            {
                label: "YBrs. Ts. Gs. Haris Freddy bin Ismail",
                value: "YBrs. Ts. Gs. Haris Freddy bin Ismail",
            },
            {
                label: "YBrs. Ts. P. Geol Muhammad Mustadza bin Mazni",
                value: "YBrs. Ts. P. Geol Muhammad Mustadza bin Mazni",
            },
            {
                label: "YBrs. Ts. Wan Mohd Adib bin Wan Mohd Yusoh",
                value: "YBrs. Ts. Wan Mohd Adib bin Wan Mohd Yusoh",
            },
            {
                label: "YBrs. Ts. Dr. Kamaruzzaman Wahid",
                value: "YBrs. Ts. Dr. Kamaruzzaman Wahid",
            },
            {
                label: "YBrs. Ts. Ida Liyani binti Ahmad",
                value: "YBrs. Ts. Ida Liyani binti Ahmad",
            }
        ]
    },
    {
        label: "Telecommunication & broadcasting technology (TB)",
        value: 23,
        sub_fields: [
            {
                label: "Transmission",
                value: 1,
            },
            {
                label: "Radio Infra",
                value: 2,
            },
            {
                label: "Broadcasting",
                value: 3,
            },
            {
                label: "Studio Engineering",
                value: 4,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Azhar bin Abdul Latiff",
                value: "YBrs. Ts. Azhar bin Abdul Latiff",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Harlisya binti Hj. Harun",
                value: "YBrs. Prof. Madya Ts. Dr. Harlisya binti Hj. Harun",
            },
            {
                label: "YBrs. Ts. Tee Kok Keong",
                value: "YBrs. Ts. Tee Kok Keong",
            },
            {
                label: "YBrs. Ts. Nurulhusna binti Mohamad Kasim",
                value: "YBrs. Ts. Nurulhusna binti Mohamad Kasim",
            },
            {
                label: "YBrs. Ts. Amzari bin Ahmad Zainuddin",
                value: "YBrs. Ts. Amzari bin Ahmad Zainuddin",
            },
            {
                label: "YBrs. Ts. Kong Jun Wei",
                value: "YBrs. Ts. Kong Jun Wei",
            },
            {
                label: "YBrs. Ts. Puganeswaran a/l Kannan",
                value: "YBrs. Ts. Puganeswaran a/l Kannan",
            },
            {
                label: "YBrs. Ts. Yap Wei Keong",
                value: "YBrs. Ts. Yap Wei Keong",
            },
            {
                label: "YBrs. Ts. Ir. Mohan Dass A/L Albert",
                value: "YBrs. Ts. Ir. Mohan Dass A/L Albert",
            },
            {
                label: "YBrs. Ts. Dr. Mohd Ismifaizul bin Mohd Ismail",
                value: "YBrs. Ts. Dr. Mohd Ismifaizul bin Mohd Ismail",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Zuhanis binti Mansor",
                value: "YBrs. Prof. Madya Ts. Dr. Zuhanis binti Mansor",
            },
            {
                label: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
                value: "YBrs. Prof. Ts. Ir. Dr. Sulaiman Wadi bin Harun",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
                value: "YBrs. Prof. Madya Ts. Dr. Cheng Ee Meng",
            },
            {
                label: "YBrs. Ts. Mohd Nazri bin Johari",
                value: "YBrs. Ts. Mohd Nazri bin Johari",
            },
            {
                label: "YBrs. Prof. Madya. Ts. Ir. Dr. Rosemizi bin Abd Rahim",
                value: "YBrs. Prof. Madya. Ts. Ir. Dr. Rosemizi bin Abd Rahim",
            },
            {
                label: "YBrs. Ts. Rhoma Erma bin Zaini",
                value: "YBrs. Ts. Rhoma Erma bin Zaini",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
                value: "YBrs. Ts. Ir. Dr. Mohd Shuhaibul Fadly bin Mansor",
            },
            {
                label: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
                value: "YBrs. Prof. Madya Ts. Ir. Dr. Syed Abdul Mutalib Al Junid bin Syed Abdul Rahman",
            },
            {
                label: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
                value: "YBrs. Ts. Ir. Ahmad Azlan bin Ab. Aziz",
            },
            {
                label: "YBrs. Tc. Affendy bin Din",
                value: "YBrs. Tc. Affendy bin Din",
            },
            {
                label: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
                value: "YBhg. Laksamana Madya Dato' Ts. Shamsuddin bin Hj. Ludin",
            }
        ]
    },
    {
        label: "Transportation & logistic technology (TL)",
        value: 24,
        sub_fields: [
            {
                label: "Railway",
                value: 1,
            },
            {
                label: "Shipping",
                value: 2,
            },
            {
                label: "Road",
                value: 3,
            },
            {
                label: "Cargo",
                value: 4,
            },
            {
                label: "Warehouse",
                value: 5,
            },
            {
                label: "Supply Process",
                value: 6,
            },
            {
                label: "Inventory control",
                value: 7,
            },
            {
                label: "PSH&T (Packaging,Handling, Storage &Tracking)",
                value: 8,
            },
        ],
        panelist: [
            {
                label: "YBrs. Ts. Hisham bin Ismoi",
                value: "YBrs. Ts. Hisham bin Ismoi",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Muhammad Ashlyzan bin Razik",
                value: "YBrs. Prof. Madya Ts. Dr. Muhammad Ashlyzan bin Razik",
            },
            {
                label: "YBrs. Ts. Dr. Haryati binti Yaacob",
                value: "YBrs. Ts. Dr. Haryati binti Yaacob",
            },
            {
                label: "YBrs. Ts. Hizal Hanis bin Hashim",
                value: "YBrs. Ts. Hizal Hanis bin Hashim",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Rizal bin Razalli",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Rizal bin Razalli",
            },
            {
                label: "YBrs. Tc. Mohd Husaini bin Seman",
                value: "YBrs. Tc. Mohd Husaini bin Seman",
            },
            {
                label: "YBrs. Prof. Ts. Dr. Othman bin Che Puan",
                value: "YBrs. Prof. Ts. Dr. Othman bin Che Puan",
            },
            {
                label: "YBrs. Prof. Madya Kdr. (B) Ts. Dr. Aminuddin bin Md Arof",
                value: "YBrs. Prof. Madya Kdr. (B) Ts. Dr. Aminuddin bin Md Arof",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Fazarizul Hashidi bin Muhamad Pauzi",
                value: "YBrs. Ts. Ir. Dr. Fazarizul Hashidi bin Muhamad Pauzi",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Kasypi bin Mokhtar",
                value: "YBrs. Prof. Madya Ts. Dr. Kasypi bin Mokhtar",
            },
            {
                label: "YBrs. Ts. Ir. Dr. Rusdi bin Rusli",
                value: "YBrs. Ts. Ir. Dr. Rusdi bin Rusli",
            },
            {
                label: "YBrs. Ts. Mohd Nor Amin bin Masnuti",
                value: "YBrs. Ts. Mohd Nor Amin bin Masnuti",
            },
            {
                label: "YBrs. Ts. Dr. Julyus Melvin Mobilik",
                value: "YBrs. Ts. Dr. Julyus Melvin Mobilik",
            },
            {
                label: "YBrs. Prof. Madya Ts. Dr. Mohd Fahmy bin Abdullah",
                value: "YBrs. Prof. Madya Ts. Dr. Mohd Fahmy bin Abdullah",
            },
            {
                label: "YBrs. Ts. Mohd Ashraf bin Hj Ahmad Fauzi",
                value: "YBrs. Ts. Mohd Ashraf bin Hj Ahmad Fauzi",
            },
            {
                label: "YBrs. Ts. Ir. Rijalur Rahimi bin Mohd Roseli",
                value: "YBrs. Ts. Ir. Rijalur Rahimi bin Mohd Roseli",
            },
            {
                label: "YBrs. Ts. Mohd Firdaus bin Mohd Siam",
                value: "YBrs. Ts. Mohd Firdaus bin Mohd Siam",
            },
            {
                label: "YBrs. Ts. Zarir Hafiz bin Zulkipli",
                value: "YBrs. Ts. Zarir Hafiz bin Zulkipli",
            },
            {
                label: "YBrs. Ts. Zarina binti Rahmat",
                value: "YBrs. Ts. Zarina binti Rahmat",
            },
            {
                label: "YBrs. Ts. Norazman bin Abu Hassan",
                value: "YBrs. Ts. Norazman bin Abu Hassan",
            },
            {
                label: "YBrs. Ts. Nurul Najwa binti Nawai",
                value: "YBrs. Ts. Nurul Najwa binti Nawai",
            },
            {
                label: "YBrs. Ts. Ahmad Saife bin Salleh",
                value: "YBrs. Ts. Ahmad Saife bin Salleh",
            },
            {
                label: "YBrs. Ts. Dr. Sivanandan A/L Balakrishnan",
                value: "YBrs. Ts. Dr. Sivanandan A/L Balakrishnan",
            },
            {
                label: "YBrs. Ts. Izzatul Huda binti Mohd Jalil",
                value: "YBrs. Ts. Izzatul Huda binti Mohd Jalil",
            },
            {
                label: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
                value: "YBrs. Ts. Mohd Syaifullah bin Mohd Azali",
            }
        ]
    },
    {
        label: "Related to All Fields",
        value: 25,
    },
];

export const RACE_CONSTANTS = {
    MALAY: 1,
    CHINESE: 2,
    INDIAN: 3,
    OTHER: 4,
};

export const RACE_LABELS_AND_VALUES = generateLabelsAndValues(RACE_CONSTANTS);

export const CURRENT_WORKING_SECTOR_CONSTANTS = {
    GOVERNMENT: 1,
    PRIVATE: 2,
};

export const CURRENT_WORKING_SECTOR_LABELS_AND_VALUES = generateLabelsAndValues(CURRENT_WORKING_SECTOR_CONSTANTS);

export const findTechnologyField = (value) => {
    const data = TechnologyFieldsOptions.find((ele) => ele.value === value);
    return data?.label;
};

export const findPreferredRegistration = (value) => {
    const data = CERTIFICATE_TYPE_LABELS_VALUES?.find((ele) => ele.value === value);
    return data?.label;
};

export const findRace = (value) => {
    const data = RACE_LABELS_AND_VALUES?.find((ele) => ele.value === value);
    if (data?.value === RACE_CONSTANTS.OTHER) {
        return null;
    }
    return data?.label;
};

export const findCurrentWorkingSector = (value) => {
    const data = CURRENT_WORKING_SECTOR_LABELS_AND_VALUES?.find((ele) => ele.value === value);
    return data?.label;
};

export const step4FormInitialValues = {
    current_working_sector: "",
    scheme_jpa: "",
    scheme_jpa_other: "",
    technology_field: "",
    technology_sub_field: "",
    company_name: "",
    designation: "",
    company_address: "",
    from: "",
    to: "",
    file: "",
};

export const step3FormInitialValues = {
    type: "",
    program_name: "",
    university: "",
    from: "",
    to: "",
    field_of_study: "",
    field_of_study_other: "",
    file: "",
};

export const SCHEMA_JPA_GOVERNMENT = {
    PENGANGKUTAN: 1,
    BAKAT_DAN_SENI: 2,
    SAINS: 3,
    PENDIDIKAN: 4,
    EKONOMI: 5,
    SISTEM_MAKLAUMAT: 6,
    PERTANIAN: 7,
    KEMAHIRAN: 8,
    KEJURUTERAAN: 9,
    KESELAMATAN: 10,
    PERUNDANGAN_DAN_KEHAKIMAN: 11,
    TADBIR_DAN_DIPLOMATIK: 12,
    PENTADBIRAN_DAN_SOKONGAN: 13,
    PERNCEGAHAN: 14,
    PENTADBIRAN_DAN_PEMBANGUNAN: 15,
    SOSIAL: 16,
    PENGUAKUASAAN_MARITIM: 17,
    PERUBATAN_DAN_KESIHATAN: 18,
    KEWANGAN: 19,
    POLIS: 20,
    TENTERA: 21,
};

export const SCHEMA_JPA_PRIVATE = {
    INDUSTRY: 22,
    IPTS_ILKS: 23,
    OTHERS: 24,
};

export const SchemeJpaGovLabelsAndValues = generateLabelsAndValues(SCHEMA_JPA_GOVERNMENT);

export const SchemeJpaPvtLabelsAndValues = generateLabelsAndValues(SCHEMA_JPA_PRIVATE);

export const WORKING_SECTOR = {
    GOVERNMENT: "government",
    PRIVATE: "private",
};

export const TYPE_OF_QUALIFICATION_CONSTANTS = {
    DOCTORAL_DEGREE: 1,
    MASTER_DEGREE: 2,
    BACHELOR_DEGREE: 3,
    ADVANCED_DIPLOMA: 4,
    DIPLOMA: 5,
    CERTIFICATE_LEVEL_3: 6,
    CERTIFICATE_OF_COMPETENCY: 7,
};

export const QualificationLabelsAndValues = generateLabelsAndValues(TYPE_OF_QUALIFICATION_CONSTANTS);

export const getTypeNameByType = (type) => {
    const qualification = QualificationLabelsAndValues.find((q) => q.value === type);
    return qualification.label;
};

export const FIELD_OF_STUDY_CONSTANTS = {
    ENGINEERING: 1,
    ENGINEERING_TECHNOLOGY: 2,
    TECHNOLOGY_AND_TECHNICAL: 3,
    NON_TECHNICAL: 4,
    OTHER: 5,
};

export const ProgrammeLabelsAndValues = generateLabelsAndValues(FIELD_OF_STUDY_CONSTANTS);

export const CertificateNamePrefix = {
    1: "Gt.",
    2: "Qt.",
    3: "Ts.",
    4: "Tc.",
};

export const SECRITARIAT = {
    "Puan Nurul Hafiza binti Jusoh": "Puan Nurul Hafiza binti Jusoh",
    "Puan Khairunnisa binti Mokhiri": "Puan Khairunnisa binti Mokhiri",
    "Puan Nurjariah binti Jamil": "Puan Nurjariah binti Jamil",
    "Puan Tuan Nooraiza binti Tuan Ismail": "Puan Tuan Nooraiza binti Tuan Ismail",
    "Puan Liyana Yasmin binti Rohani": "Puan Liyana Yasmin binti Rohani",
};

export const Secritariat_labels_values = generateLabelsAndValuesforPanelist(SECRITARIAT);

export const PANELIST = {
    Noor_Hisham_Yahaya: "Noor Hisham Yahaya",
    Wan_Mansor_Bin_Wan_Muhamad: "Wan Mansor Bin Wan Muhamad",
    Ricky_Liew_Chee_Leong: "Ricky Liew Chee Leong",
    Joel_Lim_Soon_Yeen: "Joel Lim Soon Yeen",
    Mohd_Shahrizan_Bin_Asmawi: "Mohd Shahrizan Bin Asmawi",
    Hayroman_Ahmad: "Hayroman Ahmad",
    Izatul_Hamimi_Binti_Abdul_Razak: "Izatul Hamimi Binti Abdul Razak",
    Mohd_Razif_Bin_Idris: "Mohd Razif Bin Idris",
    Mohamad_Ali_Ahmad: "Mohamad Ali Ahmad",
    Tan_Chin_Ike: "Tan Chin Ike",
    "Noor_Azurati_Ahmad_@_Salleh": "Noor Azurati Ahmad @ Salleh",
    Nor_Masri_Sahri: "Nor Masri Sahri",
    Zulkefli_Mansor: "Zulkefli Mansor",
    Neo_Tse_Kian: "Neo Tse Kian",
    Noor_Afiza_Binti_Mat_Razali: "Noor Afiza Binti Mat Razali",
    Ramesh_Sabapathy: "Ramesh Sabapathy",
    Hisham_Bin_Ismoi: "Hisham Bin Ismoi",
    Wan_Azdi_Bin_Wan_Omar: "Wan Azdi Bin Wan Omar",
    Mohammad_Zaharudin_Bin_Ahmad_Darus: "Mohammad Zaharudin Bin Ahmad Darus",
    Ahmad_Zaki_Bin_Abdul_Karim: "Ahmad Zaki Bin Abdul Karim",
    Ridzuan_Bin_Md_Sham: "Ridzuan Bin Md. Sham",
    Yam_Teong_Sian: "Yam Teong Sian",
    Kamarul_Adnan_B_Abd_Aziz: "Kamarul Adnan B Abd Aziz",
    Mohammad_Taufiq_Bin_Mustaffa: "Mohammad Taufiq Bin Mustaffa",
    Aidil_Shafiza_Bin_Safiee: "Aidil Shafiza Bin Safiee",
    Zainal_Bin_Zakaria: "Zainal Bin Zakaria",
    Jaafar_Bin_Abdullah: "Jaafar Bin Abdullah",
    Sulzakimin_Bin_Mohamed: "Sulzakimin Bin Mohamed",
    "Emran_@_Zahrin_Bin_Mohamad_Taram": "Emran @ Zahrin Bin Mohamad Taram",
    Ahmad_Azrem_Bin_Azmi: "Ahmad Azrem Bin Azmi",
    Mohammad_Tamizi_Selimin: "Mohammad Tamizi Selimin",
    Mohd_Fazli_Bin_Ismail: "Mohd Fazli Bin Ismail",
    "Wan_Mohd_Arif_Bin_W._Ibrahim": "Wan Mohd Arif Bin W. Ibrahim",
    Che_Ku_Mohammad_Faizal_Bin_Che_Ku_Yahya: "Che Ku Mohammad Faizal Bin Che Ku Yahya",
    Wan_Mohd_Khairul_Wan_Mohamed_Zin: "Wan Mohd Khairul Wan Mohamed Zin",
    Mohd_Sharizan_Md_Sarip: "Mohd Sharizan Md Sarip",
    Noraimi_Bin_Shafie: "Noraimi Bin Shafie",
    Mohd_Faizul_Bin_Md_Idros: "Mohd Faizul Bin Md Idros",
    "Mohd_Razdi_Bin_Omar_Lt_Kdr_(R)_Tldm": "Mohd Razdi Bin Omar Lt Kdr (R) Tldm",
    Hashimah_Binti_Hashim: "Hashimah Binti Hashim",
    Farah_Binti_Abu_Bakar: "Farah Binti Abu Bakar",
    Wan_Zulkarnain_Bin_Othman: "Wan Zulkarnain Bin Othman",
    Mohamad_Yusof_Bin_Maskat: "Mohamad Yusof Bin Maskat",
    Zakiman_Bin_Zali: "Zakiman Bin Zali",
    Shahril_Bin_Jalil: "Shahril Bin Jalil",
    Azhar_Bin_Abdul_Latiff: "Azhar Bin Abdul Latiff",
    Azmi_Bin_Ramli: "Azmi Bin Ramli",
    Nor_Azma_Binti_Yusuf: "Nor Azma Binti Yusuf",
    Mohd_Muzaffar_Bin_Zahar: "Mohd Muzaffar Bin Zahar",
    Rosemizi_Abd_Rahim: "Rosemizi Abd Rahim",
    Mohd_Fairuz_Bin_Mohd_Rashid: "Mohd Fairuz Bin Mohd Rashid",
    Shafriza_Nisha_Bin_Basah: "Shafriza Nisha Bin Basah",
    "Lokman_Hakim_Bin_Hj._Ismail": "Lokman Hakim Bin Hj. Ismail",
    Mohd_Kamaruzaman_Bin_Musa: "Mohd Kamaruzaman Bin Musa",
    Norhaizura_Binti_Yahya: "Norhaizura Binti Yahya",
    Mohd_Shuzainy_Bin_Ismail: "Mohd Shuzainy Bin Ismail",
    Mohd_Firdaus_Bin_Mustaffa_Kamal: "Mohd Firdaus Bin Mustaffa Kamal",
    Mohd_Mawardi_Bin_Hassim: "Mohd Mawardi Bin Hassim",
    Azizul_Hasri_Bin_Sabri: "Azizul Hasri Bin Sabri",
    "Azura_Binti_A._Rashid": "Azura Binti A. Rashid",
    Mohd_Shuhaibul_Fadly_Bin_Mansor: "Mohd Shuhaibul Fadly Bin Mansor",
    Nor_Hisham_Bin_Mohamed_Mahayudin: "Nor Hisham Bin Mohamed Mahayudin",
    Zulhafiz_Bin_Tajudin: "Zulhafiz Bin Tajudin",
    Nik_Zulkarnaen_Bin_Khidzir: "Nik Zulkarnaen Bin Khidzir",
    Muhamad_Nazeer_Bin_Haji_Yusof: "Muhamad Nazeer Bin Haji Yusof",
    Hazrizam_Ab_Rahim: "Hazrizam Ab Rahim",
    "Mohamad_Yusri_Bin_Hj._Yusoff": "Mohamad Yusri Bin Hj. Yusoff",
    Latifah_Binti_Md_Ariffin: "Latifah Binti Md Ariffin",
    Zuhailawati_Hussain: "Zuhailawati Hussain",
    Hasmaliza_Mohamad: "Hasmaliza Mohamad",
    Anasyida_Abu_Seman: "Anasyida Abu Seman",
    Kon_Qi_Yao: "Kon Qi Yao",
    Zuratul_Ain_Abdul_Hamid: "Zuratul Ain Abdul Hamid",
    Gunalaan_Vasudevan: "Gunalaan Vasudevan",
    Mohamad_Hairi_bin_Osman: "Mohamad Hairi bin Osman",
    Nik_Mohd_Nadzri_Bin_Nik_Mustapha: "Nik Mohd Nadzri Bin Nik Mustapha",
    Pung_Swee_Yong: "Pung Swee Yong",
    Suria_Adam_Daneil_Tomo: "Suria Adam Daneil Tomo",
    Musa_Bin_Mohd_Yusuf: "Musa Bin Mohd Yusuf",
    Chong_Chee_Yen: "Chong Chee Yen",
    Wan_Mohd_Sufian_Bin_Wan_Husain: "Wan Mohd Sufian Bin Wan Husain",
    Ong_Seng_Keong: "Ong Seng Keong",
    "R.Karnanethe_(PJK)": "R.Karnanethe (PJK)",
    Mohd_Yusaini_bin_Mohd_Yunus: "Mohd Yusaini bin Mohd Yunus",
    Shahrul_Niza_bin_Samsudin: "Shahrul Niza bin Samsudin",
    Muhamad_Yusof_Bin_Abdullah: "Muhamad Yusof Bin Abdullah",
    Shum_Wai_Koon: "Shum Wai Koon",
    Khoo_Boo_Kean: "Khoo Boo Kean",
    Muhammad_Ikhwan_Bin_Zamhuri: "Muhammad Ikhwan Bin Zamhuri",
    Rainal_Hidayat_Bin_Wardi: "Rainal Hidayat Bin Wardi",
    Ho_Yoong_Chow: "Ho Yoong Chow",
    Mohd_Shairul_Bin_Harun: "Mohd Shairul Bin Harun",
    Azam_Nurshahriman_Bin_Zakaria: "Azam Nurshahriman Bin Zakaria",
    Abdul_Halim_Bin_Abdullah: "Abdul Halim Bin Abdullah",
    Norbaya_Binti_Haji_Sidek: "Norbaya Binti Haji Sidek",
    Rafidah_Binti_Hamdan: "Rafidah Binti Hamdan",
    Siti_Birkha_Binti_Mohd_Ali: "Siti Birkha Binti Mohd Ali",
    Sabariah_Binti_Musa: "Sabariah Binti Musa",
    Siti_Hartini_Binti_Hamdan: "Siti Hartini Binti Hamdan",
    Roslaili_Binti_Abdul_Aziz: "Roslaili Binti Abdul Aziz",
    Jalina_Binti_Kassim: "Jalina Binti Kassim",
    Roshita_Binti_Ibrahim: "Roshita Binti Ibrahim",
    Maryana_Binti_Mohamad_Nor: "Maryana Binti Mohamad Nor",
    Izzatul_Huda_Binti_Mohd_Jalil: "Izzatul Huda Binti Mohd Jalil",
    Muhammad_Ashlyzan_Bin_Razik: "Muhammad Ashlyzan Bin Razik",
    Haryati_Binti_Yaacob: "Haryati Binti Yaacob",
    Hizal_Hanis_Bin_Hashim: "Hizal Hanis Bin Hashim",
    Hanida_Binti_Abdullah: "Hanida Binti Abdullah",
    Junita_Binti_Mohd_Nordin: "Junita Binti Mohd Nordin",
    Mohd_Shukri_Bin_Mohd_Aris: "Mohd Shukri Bin Mohd Aris",
    Mohamad_Hafiz_Bin_Mamat: "Mohamad Hafiz Bin Mamat",
    Amir_Syahir_Bin_Amir_Hamzah: "Amir Syahir Bin Amir Hamzah",
    Mohd_Rizal_Bin_Razalli: "Mohd Rizal Bin Razalli",
    Haris_Fazilah_Bin_Hassan: "Haris Fazilah Bin Hassan",
    Muzamir_bin_Isa: "Muzamir bin Isa",
    Wan_Zarina_Binti_Wan_Mohamed: "Wan Zarina Binti Wan Mohamed",
    Norazana_Binti_Ibrahim: "Norazana Binti Ibrahim",
    Salmiaton_Ali: "Salmiaton Ali",
    Azmi_Bin_Ahmad: "Azmi Bin Ahmad",
    Mohamed_Ibrahim_Bin_Abdul_Mutalib: "Mohamed Ibrahim Bin Abdul Mutalib",
    Norziana_Binti_Jamil: "Norziana Binti Jamil",
    Suzana_Binti_Basaruddin: "Suzana Binti Basaruddin",
    Harlisya_Hj_Harun: "Harlisya Hj. Harun",
    Tee_Thian_Soon: "Tee Thian Soon",
    Mohd_Noramin_Bin_Ab_Aziz: "Mohd Noramin Bin Ab Aziz",
    Ho_Chee_Leong: "Ho Chee Leong",
    Amiza_Binti_Mat_Amin: "Amiza Binti Mat Amin",
    Mohd_Safiee_bin_Idris: "Mohd Safiee bin Idris",
    SITI_NOOR_HIDAYAH_BINTI_MUSTAPHA: "SITI NOOR HIDAYAH BINTI MUSTAPHA",
    Muammar_bin_Mohamad_Isa: "Muammar bin Mohamad Isa",
    Syahrul_bin_Manap: "Syahrul bin Manap",
    Mohd_Rosmaini_Bin_Shaari: "Mohd Rosmaini Bin Shaari",
    Nordin_bin_Ayoub: "Nordin bin Ayoub",
    Saiful_Bahri_Bin_Hamzah: "Saiful Bahri Bin Hamzah",
    Mohd_Hafiz_Bin_Ab_Rahman: "Mohd Hafiz Bin Ab Rahman",
    Wong_Chui_Yin: "Wong Chui Yin",
    Mohd_Ruzaimi_Bin_Mat_Rejab: "Mohd Ruzaimi Bin Mat Rejab",
    Zainon_Binti_Mat_Sharif: "Zainon Binti Mat Sharif",
    Mohd_Soffian_Bin_Osman: "Mohd Soffian Bin Osman",
    Safian_Bin_Sharif: "Safian Bin Sharif",
    Jansi_Bin_Jainu: "Jansi Bin Jainu",
    Mohd_Khairulnizam_Bin_Mohmmed_Haasan: "Mohd Khairulnizam Bin Mohmmed Haasan",
    Mohd_Farihan_Bin_Jamaludin: "Mohd Farihan Bin Jamaludin",
    "Mohamad_Fairuz_Bin_Ya'ccob": "Mohamad Fairuz Bin Ya'ccob",
    Azrol_bin_Jailani: "Azrol bin Jailani",
    Mahdir_Bin_Mahmood: "Mahdir Bin Mahmood",
    "Ahmad_Azlan_Bin_Ab._Aziz": "Ahmad Azlan Bin Ab. Aziz",
    Segar_Rajamanickam: "Segar Rajamanickam",
    Zamrin_Md_Zin: "Zamrin Md Zin",
    Abdul_Khalil_Shawkataly: "Abdul Khalil Shawkataly",
    Shamsiah_Abdullah: "Shamsiah Abdullah",
    Mohd_Fazil_Bin_Jundam: "Mohd. Fazil Bin Jundam",
    Noor_Zaitun_Yahaya: "Noor Zaitun Yahaya",
    Nurulhusna_Bt_Mohamad_Kasim: "Nurulhusna Bt. Mohamad Kasim",
    Mohamad_Halim_Bin_Ibrahim: "Mohamad Halim Bin Ibrahim",
    Choong_Chee_Guan: "Choong Chee Guan",
    Che_Ghani_Bin_Che_Kob: "Che Ghani Bin Che Kob",
    Zunuwanas_bin_Mohamad: "Zunuwanas bin Mohamad",
    Muhamad_Razuhanafi_Bin_Mat_Yazid: "Muhamad Razuhanafi Bin Mat Yazid",
    Mohamad_Sukor_Bin_Zainal_Abidin: "Mohamad Sukor Bin Zainal Abidin",
    Azmi_bin_Sidek: "Azmi bin Sidek",
    Mohd_Nazri_Bin_Omar: "Mohd Nazri Bin Omar",
    Mohd_Ghazali_bin_Abdul_Rahman: "Mohd Ghazali bin Abdul Rahman",
    Ameran_Bin_Saiman: "Ameran Bin Saiman",
    Muhamad_Azwat_Bin_Abdullah: "Muhamad Azwat Bin Abdullah",
    Nor_Paezah_Binti_Abdullah: "Nor Paezah Binti Abdullah",
    Aminuddin_Md_Arof: "Aminuddin Md Arof",
    Irmaizatussyehdany_Binti_Buniyamin: "Irmaizatussyehdany Binti Buniyamin",
    Zainudin_Bin_Jusoh: "Zainudin Bin Jusoh",
    Rusmadiah_Bin_Anwar: "Rusmadiah Bin Anwar",
    Soong_Cai_Juan: "Soong Cai Juan",
    Adnan_Bin_Derahman: "Adnan Bin Derahman",
    Amzari_Bin_Ahmad_Zainuddin: "Amzari Bin Ahmad Zainuddin",
    Solehuddin_Bin_Shuib: "Solehuddin Bin Shuib",
    Mohd_Zulhafiz_Bin_Mohd_Yajid: "Mohd Zulhafiz Bin Mohd Yajid",
    Siti_Mariam_binti_Tajuddin: "Siti Mariam binti Tajuddin",
    Rumaizah_Binti_Mohd_Nordin: "Rumaizah Binti Mohd Nordin",
    Ahmad_Aftas_Bin_Azman: "Ahmad Aftas Bin Azman",
    "Ruzainah_Binti_Ali_@_Jaafar": "Ruzainah Binti Ali @ Jaafar",
    Mohd_Husaini_Bin_Seman: "Mohd Husaini Bin Seman",
    Luqman_Bin_Musa: "Luqman Bin Musa",
    Faizah_Abu_Bakar: "Faizah Abu Bakar",
    Abdul_Halim_Bin_Abd_Rahman: "Abdul Halim Bin Abd Rahman",
    SYED_ABDUL_MUTALIB_AL_JUNID: "SYED ABDUL MUTALIB AL JUNID",
    Mohd_Firdaus_bin_Omar: "Mohd Firdaus bin Omar",
    Mohd_Naim_Bin_Awang: "Mohd Naim Bin Awang",
    Hoo_Mow_Heng: "Hoo Mow Heng",
    Mohd_Nizam_Bin_Yob: "Mohd Nizam Bin Yob",
    Sulaiman_Wadi_Harun: "Sulaiman Wadi Harun",
    Tee_Kok_Keong: "Tee Kok Keong",
    Mohd_Adzrie_Bin_Radzali: "Mohd Adzrie Bin Radzali",
    Mohd_Shahril_Mohd_Yusop: "Mohd Shahril Mohd Yusop",
    MOHD_ZULHILMI_BIN_JAMALUDDIN: "MOHD ZULHILMI BIN JAMALUDDIN",
    NUR_AIMAN_BIN_BAHARUDDIN: "NUR AIMAN BIN BAHARUDDIN",
    AHMAD_HUSSEIN_BIN_ABDUL_HAMID: "AHMAD HUSSEIN BIN ABDUL HAMID",
    NURUL_AIN_BINTI_RADIN: "NURUL AIN BINTI RADIN",
    MUHAMMAD_MUSTADZA_BIN_MAZNI: "MUHAMMAD MUSTADZA BIN MAZNI",
    ABDULLAH_BIN_RAMLI: "ABDULLAH BIN RAMLI",
    AZIZI_BIN_A_HADI: "AZIZI BIN A HADI",
    ANG_KOK_YEW: "ANG KOK YEW",
    MOHAMAD_ISA_BIN_TUKIMIN: "MOHAMAD ISA BIN TUKIMIN",
    TAN_WEI_HONG: "TAN WEI HONG",
    FAZARIZUL_HASHIDI_BIN_MUHAMAD_PAUZI: "FAZARIZUL HASHIDI BIN MUHAMAD PAUZI",
    KHAIRUDIN_BIN_BAHARUM: "KHAIRUDIN BIN BAHARUM",
    ANUAR_BIN_MOHD_YUSOF: "ANUAR BIN MOHD YUSOF",
    KASYPI_BIN_MOKHTAR: "KASYPI BIN MOKHTAR",
    KAMARUL_AZMAN_BIN_MOHD_IKRAM: "KAMARUL AZMAN BIN MOHD IKRAM",
    RUSDI_BIN_RUSLI: "RUSDI BIN RUSLI",
    SITI_ZURAIDA_BINTI_MAARUF: "SITI ZURAIDA BINTI MAARUF",
    LOH_KIM_SING: "LOH KIM SING",
    KAMARUL_RAHIM_BIN_KAMARUDDIN: "KAMARUL RAHIM BIN KAMARUDDIN",
    AHMAD_SOBRI_BIN_AHMAD_HUDIN: "AHMAD SOBRI BIN AHMAD HUDIN",
    MOHD_NOR_AMIN_BIN_MASNUTI: "MOHD NOR AMIN BIN MASNUTI",
    JULYUS_MELVIN_MOBILIK: "JULYUS MELVIN MOBILIK",
    AZ_AFZAN_ZUHAIRI_BIN_MOHAMED_AZHAR: "AZ AFZAN ZUHAIRI BIN MOHAMED AZHAR",
    MUHAMMAD_FUDHAIL_BIN_ABD_RAHMAN: "MUHAMMAD FUDHAIL BIN ABD RAHMAN",
    MOHAMED_SHAH_BIN_HATTA: "MOHAMED SHAH BIN HATTA",
    CHENG_EE_MENG: "CHENG EE MENG",
    MOHD_FAHMY_BIN_ABDULLAH: "MOHD FAHMY BIN ABDULLAH",
    MOHD_MAHADZIR_BIN_MOHAMMUD: "MOHD MAHADZIR BIN MOHAMMUD",
    "NUR_RASHID_BIN_MAT_NURI_@_MD_DIN": "NUR RASHID BIN MAT NURI @ MD DIN",
    ADNAN_BIN_KATIJAN: "ADNAN BIN KATIJAN",
    MOHD_ASHRAF_BIN_HJ_AHMAD_FAUZI: "MOHD ASHRAF BIN HJ AHMAD FAUZI",
    WAN_AIDA_WAN_YAHYA: "WAN AIDA WAN YAHYA",
    TEOH_THEAN_HIN: "TEOH THEAN HIN",
    AZLI_BIN_ITHNAIN: "AZLI BIN ITHNAIN",
    MOHINI_BIN_KAMARUDDIN: "MOHINI BIN KAMARUDDIN",
    NOOR_AKHMAZILLAH_BT_MOHD_FAUZI: "NOOR AKHMAZILLAH BT MOHD FAUZI",
    WAN_HASMAR_AZIM_WAN_HASSAN: "WAN HASMAR AZIM WAN HASSAN",
    AHMAD_MUJAHID_BIN_AHMAD_ZAIDI: "AHMAD MUJAHID BIN AHMAD ZAIDI",
    MARIA_BINTI_HJ_MOHAMMAD: "MARIA BINTI HJ MOHAMMAD",
    LIM_EAN_HENG: "LIM EAN HENG",
    NORAINI_BINTI_SEMAN: "NORAINI BINTI SEMAN",
    "Ahmad_Nasruddin_'Atiqullah_Fakrullah": "Ahmad Nasruddin 'Atiqullah Fakrullah",
    Mohd_Nazrol_bin_Marzuke: "Mohd Nazrol bin Marzuke",
    ELMAN_BIN_MUSTAFA_EL_BAKRI: "ELMAN BIN MUSTAFA EL BAKRI",
    JASMY_BIN_YUNUS: "JASMY BIN YUNUS",
    AKBAL_BIN_ABU: "AKBAL BIN ABU",
    MUHAMAD_SAHIR_BIN_AHMAD_SHATIRY: "MUHAMAD SAHIR BIN AHMAD SHATIRY",
    MOHD_FAIZAL_GHAZALI: "MOHD FAIZAL GHAZALI",
    AZLAN_ABU_BAKAR: "AZLAN ABU BAKAR",
    MOHD_SYAIFULLAH_BIN_MOHD_AZALI: "MOHD SYAIFULLAH BIN MOHD AZALI",
    MOHD_AMIR_FIKRI_BIN_BASRI: "MOHD AMIR FIKRI BIN BASRI",
    KHAIRAN_SYUHADA_BINTI_KASSIM: "KHAIRAN SYUHADA BINTI KASSIM",
    AZRIHAL_AMIR_RAMADAN: "AZRIHAL AMIR RAMADAN",
    MOHAMAD_RIDZUAN_BIN_SANI: "MOHAMAD RIDZUAN BIN SANI",
    ZULKIFLI_BIN_MAHMOODIN: "ZULKIFLI BIN MAHMOODIN",
    MOHD_AZRIN_BIN_ROSELAN: "MOHD AZRIN BIN ROSELAN",
    Hassan_Bin_Mohamed: "Hassan Bin Mohamed",
    Mohamad_Annuar_Assadat_bin_Husain: "Mohamad Annuar Assadat bin Husain",
    MOHD_TAHA_BIN_SUJA: "MOHD TAHA BIN SUJA",
    "Wan_Mohd_Adib_b._Wan_Mohd_Yusoh": "Wan Mohd Adib b. Wan Mohd Yusoh",
    Kelvin_Tang_Kang_Wee: "Kelvin Tang Kang Wee",
    Mohd_Hasmadi_Bin_Ismail: "Mohd Hasmadi Bin Ismail",
    Eric_Goh_Kok_Hoe: "Eric Goh Kok Hoe",
    KIEW_BOON_YAN: "KIEW BOON YAN",
    RIZATULAZRI_BIN_IDRIS: "RIZATULAZRI BIN IDRIS",
    HARIS_FREDDY_BIN_ISMAIL: "HARIS FREDDY BIN ISMAIL",
    HAMIMAH_BINTI_UJIR: "HAMIMAH BINTI UJIR",
    MUHAMMAD_SYUKRI_IMRAN_BIN_ABDULLAH: "MUHAMMAD SYUKRI IMRAN BIN ABDULLAH",
    HAFSAH_BINTI_ZABIDI: "HAFSAH BINTI ZABIDI",
    AHMAD_ZAWAWI_BIN_KASMIN: "AHMAD ZAWAWI BIN KASMIN",
    LIEW_FOONG_CHING: "LIEW FOONG CHING",
    LAU_YEW_NEN: "LAU YEW NEN",
    ANDY_TIONG_MENG_JUN: "ANDY TIONG MENG JUN",
    Siti_Hanom_Binti_Marjuni: "Siti Hanom Binti Marjuni",
    Norsaadah_Zakaria: "Norsaadah Zakaria",
    Amirul_Bin_Sait: "Amirul Bin Sait",
    Kismet_Anak_Hong_Ping: "Kismet Anak Hong Ping",
    "Jaidil_@_Jaiden_bin_Yakop": "Jaidil @ Jaiden bin Yakop",
    Mohamad_Yusri_bin_Morshidi: "Mohamad Yusri bin Morshidi",
    Mohammad_Ikhsan_bin_Mohamad_Bahrin: "Mohammad Ikhsan bin Mohamad Bahrin",
    Mohamad_Firdaus_bin_Ibrahim: "Mohamad Firdaus bin Ibrahim",
    Nelson_Gani_AK_Langan: "Nelson Gani AK Langan",
    Md_Redzuan_Zoolfakar: "Md Redzuan Zoolfakar",
    Khairini_Melissa_Ng_Sau_Cheng: "Khairini Melissa Ng Sau Cheng",
    Hazrool_Rizal_bin_Abdul_Rahim: "Hazrool Rizal bin Abdul Rahim",
    Yuganes_Ap_M_Chandran: "Yuganes Ap M Chandran",
    Mohammed_Khairil_Adzhar_Mohammed: "Mohammed Khairil Adzhar Mohammed",
    Mohd_Rizal_bin_Atan: "Mohd Rizal bin Atan",
    Ahmad_Hadinata_bin_Fauzi: "Ahmad Hadinata bin Fauzi",
    Nurul_Hazwani_binti_Hamzah: "Nurul Hazwani binti Hamzah",
    Jaiz_Anuar_Yeop_Johari: "Jaiz Anuar Yeop Johari",
    Nor_Faiz_Bin_Muhammad_Noor: "Nor Faiz Bin Muhammad Noor",
    Mohd_Fathi_Syahid_bin_Ruzali: "Mohd Fathi Syahid bin Ruzali",
    Ng_Wei_Khiang: "Ng Wei Khiang",
    HUZAINI_BIN_MOHD_NOOR: "HUZAINI BIN MOHD NOOR",
    Salim_Bin_Mohamad_Ghani: "Salim Bin Mohamad Ghani",
    George_Decruz: "George Decruz",
    Saifuladili_bin_Jaafar: "Saifuladili bin Jaafar",
    Zamzul_Khairi_Bin_Zulkifli: "Zamzul Khairi Bin Zulkifli",
    Mujahidah_Sholihah_bt_Hj_Rosli: "Mujahidah Sholihah bt Hj Rosli",
    MOHAMAD_FARIZ_BIN_MOHAMED_NASIR: "MOHAMAD FARIZ BIN MOHAMED NASIR",
    Rhoma_Erma_bin_Zaini: "Rhoma Erma bin Zaini",
    ASMIRA_BIN_ASHARI: "ASMIRA BIN ASHARI",
    Uda_Bin_Sarimin: "Uda Bin Sarimin",
};
export const Panelist_labels_values = generateLabelsAndValuesforPanelist(PANELIST);

export const TIMESLOTOPTIONS = {
    "09.00 AM - 09.30 AM": 1,
    "09.30 AM - 10.00 AM": 2,
    "10.00 AM - 10.30 AM": 3,
    "10.30 AM - 11.00 AM": 4,
    "11.00 AM - 11.30 AM": 5,
    "11.30 AM - 12.00 PM": 6,
    "12.00 PM - 12.30 PM": 7,
    "02.00 PM - 02.30 PM": 8,
    "02.30 PM - 03.00 PM": 9,
    "03.00 PM - 03.30 PM": 10,
    "03.30 PM - 04.00 PM": 11,
    "04.00 PM - 04.30 PM": 12,
    "04.30 PM - 05.00 PM": 13,
    "05.00 PM - 05.30 PM": 14,
};

export const Time_Slot_Options = generateLabelsAndValues(TIMESLOTOPTIONS);

export const ENDORSEMENT_STATUS_OBJECT = {
    1: "REJECTED",
    2: "APPROVED",
    3: "PENDING",
};

export const TECHNICAL_TECHNOLOGICAL_SERVICES_GT = {
    PRODUCT_DEVELOPMENT: 1,
    PRODUCT_MANUFACTURING: 2,
    PRODUCT_TESTING: 3,
    PRODUCT_COMMISSIONING: 4,
    PRODUCT_MAINTENANCE: 5,
};

export const TECHNICAL_TECHNOLOGICAL_SERVICES_QT = {
    PRODUCT_TESTING: 6,
    PRODUCT_COMMISSIONING: 7,
    PRODUCT_MAINTENANCE: 8,
};

export const TechTechnoServicesGTLabelsAndValues = generateLabelsAndValuesAndServices(TECHNICAL_TECHNOLOGICAL_SERVICES_GT);

export const TechTechnoServicesQTLabelsAndValues = generateLabelsAndValuesAndServices(TECHNICAL_TECHNOLOGICAL_SERVICES_QT);
